import { storeToRefs as ne, defineStore as Rn, createPinia as uo } from "pinia";
import { defineComponent as Ln, shallowRef as Pe, onMounted as Le, computed as le, watch as Ee, createElementBlock as _, openBlock as h, normalizeStyle as ze, normalizeClass as ye, createElementVNode as i, mergeProps as fo, renderSlot as In, Fragment as ce, renderList as qe, createVNode as oe, reactive as po, watchEffect as Mn, onUnmounted as Ye, useCssVars as mo, unref as d, withDirectives as G, createCommentVNode as Q, withModifiers as rt, setBlockTracking as fn, vShow as pn, ref as J, getCurrentInstance as Mt, createStaticVNode as vo, createBlock as me, Teleport as ho, Transition as Ht, withCtx as ve, toDisplayString as W, render as mn, resolveDirective as we, createTextVNode as ee, mergeModels as Vt, useModel as Dn, vModelText as go, onBeforeUnmount as _o, onActivated as bo, useTemplateRef as Dt, KeepAlive as yo, resolveDynamicComponent as wo, nextTick as vn, defineCustomElement as Co } from "vue";
import { promiseStatesHook as zn, Method as Nn, setCache as zt, globalConfigMap as xo, queryCache as jt, invalidateCache as $o, createAlova as Eo } from "alova";
import So from "dayjs";
const On = "momcozy-token";
function ko(e) {
  const n = document.cookie.split(";").find((s) => s.trim().startsWith(`${e}=`));
  return n ? n.trim().substring(e.length + 1) : null;
}
function To(e, t = window.location.hostname) {
  document.cookie = `${e}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=${t}; SameSite=Lax`;
}
function Kt() {
  return ko(On);
}
function Po() {
  To(On);
}
class Ro extends CustomEvent {
  constructor(t) {
    super("LUTE:AUTH:EXPIRED", { detail: t });
  }
}
function Lo(e) {
  document.body.classList.remove("momcozy-logined"), document.dispatchEvent(new Ro(e));
}
function Un() {
  return window.__MC__CONFIG__ && window.__MC__CONFIG__.apiUrl ? window.__MC__CONFIG__.apiUrl : "https://account.momcozy.com";
}
function Io(e, t) {
  let n = 0, s;
  return (...o) => {
    const c = Date.now(), u = t - (c - n);
    u <= 0 ? (n = c, e(...o)) : (clearTimeout(s), s = setTimeout(() => {
      n = Date.now(), e(...o);
    }, u));
  };
}
function Mo(e) {
  return typeof e == "number" && !Number.isNaN(e);
}
const Nt = "undefined", at = Promise, Fn = (e) => at.resolve(e), Do = (e) => at.reject(e), Xe = Object, U = void 0, zo = null, j = !0, V = !1, Xt = (e, t, n) => e.then(t, n), ft = (e, t) => e.catch(t), pt = (e, t) => e.finally(t), No = (e) => at.all(e), Oo = (e, t, n) => JSON.stringify(e, t, n), Qe = (e, t = 0) => setTimeout(e, t), Wt = (e) => clearTimeout(e), Hn = (e) => Xe.keys(e), Vn = (e) => Xe.values(e), Ge = (e, t) => e.forEach(t), Ke = (e, ...t) => e.push(...t), He = (e, t) => e.map(t), mt = (e, t) => e.filter(t), Uo = (e) => e.shift(), Be = (e, t, n = 0, ...s) => e.splice(t, n, ...s), fe = (e) => e.length, vt = (e) => Array.isArray(e), Qt = (e, t) => delete e[t], Jt = (e) => typeof e, st = (e, t) => e.includes(t);
typeof window === Nt && (typeof process !== Nt && process.cwd);
const At = "memory", Fo = "restore", Re = () => {
}, Ho = (e) => e, be = (e) => Jt(e) === "function", Se = (e) => Jt(e) === "number" && !Number.isNaN(e), Vo = (e) => Jt(e) === "string", jn = (e) => Xe.prototype.toString.call(e), jo = (e) => jn(e) === "[object Object]", je = (e, t) => e instanceof t, ht = (e) => e ? e.getTime() : Date.now(), Wn = (e) => e.context, Wo = (e) => e.config, We = (e) => e.key, An = (e, t, n = []) => {
  const s = be(e) ? e(...n) : e;
  return t(!!s.key, "hook handler must be a method instance or a function that returns method instance"), s;
}, Ao = (e) => {
  const t = jn(e);
  return /^\[object (Blob|FormData|ReadableStream|URLSearchParams)\]$/i.test(t) || je(e, ArrayBuffer);
}, wt = (e, ...t) => Xe.assign(e, ...t), qo = (e, ...t) => {
  const n = {};
  for (const s in e)
    t.includes(s) || (n[s] = e[s]);
  return n;
};
function qn() {
  let e, t;
  return { promise: new Promise((s, o) => {
    e = s, t = o;
  }), resolve: e, reject: t };
}
const Bo = (e) => {
  const { cacheFor: t } = Wo(e), n = (f) => Se(f) ? ht() + f : ht(f || U);
  let s = At, o = () => 0, c = V, u = U;
  const p = be(t);
  if (!p) {
    let f = t;
    if (jo(t)) {
      const { mode: l = At, expire: r, tag: a } = t || {};
      s = l, c = l === Fo, u = a ? a.toString() : U, f = r;
    }
    o = (l) => n(be(f) ? f({ method: e, mode: l }) : f);
  }
  return {
    f: t,
    c: p,
    e: o,
    m: s,
    s: c,
    t: u
  };
}, _e = (e, ...t) => new e(...t), Bn = (e, t = []) => be(e) ? e(...t) : e, Yo = (e = 0) => {
  let t = U;
  return (n) => {
    t && clearTimeout(t), t = Qe(n, e);
  };
}, Go = (e = V) => {
  const t = [];
  let n = U, s = !1;
  const o = async () => {
    for (s = j; fe(t) > 0; ) {
      const p = Uo(t);
      p && await p();
    }
    n && n(), s = V;
  };
  return {
    addQueue: (p) => _e(at, (f, l) => {
      Ke(t, () => Xt(p(), f, (a) => {
        e ? f(U) : l(a);
      })), s || o();
    }),
    onComplete: (p) => {
      n = p;
    }
  };
}, Ko = "$a.", Xo = (e, t) => Ko + e + t;
class Qo extends Error {
  constructor(t, n, s) {
    super(n + (s ? `

For detailed: https://alova.js.org/error#${s}` : "")), this.name = `[alova${t ? `/${t}` : ""}]`;
  }
}
const Ct = (e = "") => (t, n, s) => {
  if (!t)
    throw _e(Qo, e, n, s);
}, Jo = JSON.parse, Zo = () => Jo.bridgeData || {}, es = () => {
  const e = {};
  return {
    eventMap: e,
    on(t, n) {
      const s = e[t] = e[t] || [];
      return Ke(s, n), () => {
        e[t] = mt(s, (o) => o !== n);
      };
    },
    off(t, n) {
      const s = e[t];
      if (s)
        if (n) {
          const o = s.indexOf(n);
          o > -1 && s.splice(o, 1);
        } else
          delete e[t];
    },
    emit(t, n) {
      const s = e[t] || [];
      return He(s, (o) => o(n));
    }
  };
};
class ot {
  constructor(t, n, s, o) {
    this.s = t, this.k = n, this.$dhy = s, this.$exp = o;
  }
  get v() {
    return this.$dhy(this.s);
  }
  get e() {
    return this.$exp(this.s);
  }
}
class hn extends ot {
  constructor(t, n, s, o, c) {
    super(t, n, s, o), this.$upd = c;
  }
  set v(t) {
    this.$upd(this.s, t);
  }
  get v() {
    return super.v;
  }
}
const ts = (e, t) => {
  let n = zo;
  return function(...o) {
    const c = e.bind(this, ...o), u = Se(t) ? t : t(...o);
    n && Wt(n), u > 0 ? n = Qe(c, u) : c();
  };
}, ns = (e, t) => {
  const n = {};
  for (const s in e)
    n[s] = t(e[s], s, e);
  return n;
};
var ke;
(function(e) {
  e[e.USE_REQUEST = 1] = "USE_REQUEST", e[e.USE_WATCHER = 2] = "USE_WATCHER", e[e.USE_FETCHER = 3] = "USE_FETCHER";
})(ke || (ke = {}));
function Yn(e, t = { trackedKeys: {}, bindError: V, ...Zo() }) {
  const n = (r) => e.ref ? e.ref(r) : { current: r };
  t = n(t).current;
  const s = (r) => (e.export || Ho)(r, t), o = (r) => {
    if (!be(e.memorize))
      return r;
    const a = e.memorize(r);
    return a.memorized = j, a;
  }, { dehydrate: c } = e, u = (r, a, v) => r !== c(a, v, t) && t.trackedKeys[v] && e.update(r, a, v, t), p = (r) => He(r, (a) => je(a, ot) ? a.e : a), f = [], l = {};
  return {
    create: (r, a) => (Ke(f, a), _e(hn, e.create(r, a, t), a, (v) => c(v, a, t), s, (v, m) => u(m, v, a))),
    computed: (r, a, v) => (Ge(a, (m) => {
      m.k && (l[m.k] = j);
    }), _e(ot, e.computed(r, p(a), v, t), v, (m) => c(m, v, t), s)),
    effectRequest: (r) => e.effectRequest(r, t),
    ref: n,
    watch: (r, a) => e.watch(p(r), a, t),
    onMounted: (r) => e.onMounted(r, t),
    onUnmounted: (r) => e.onUnmounted(r, t),
    memorize: o,
    /**
     * refering object that sharing some value with this object.
     */
    __referingObj: t,
    /**
     * expose provider for specified use hook.
     * @param object object that contains state proxy, framework state, operating function and event binder.
     * @returns provider component.
     */
    exposeProvider: (r) => {
      const a = {}, v = {}, m = [];
      for (const k in r) {
        const C = r[k];
        if (be(C) && !t.trackedKeys[k])
          a[k] = k.startsWith("on") ? (...E) => (C(...E), R) : C.memorized ? C : o(C);
        else {
          !st(["uploading", "downloading"], k) && !k.startsWith("__") && Ke(m, k);
          const E = je(C, ot);
          E && (v[k] = C.s), Xe.defineProperty(a, k, {
            get: () => (t.trackedKeys[k] = j, E ? C.e : C),
            // set need to set an function,
            // otherwise it will throw `TypeError: Cannot set property __referingObj of #<Object> which has only a getter` when setting value
            set: Re,
            enumerable: j,
            configurable: j
          });
        }
      }
      const { update: w, __proxyState: g } = a;
      t.trackedKeys = {
        ...l
      }, t.bindError = V;
      const { then: S } = a, x = {
        // expose referingObject automatically.
        __referingObj: t,
        // the new updating function that can update the new states and nested hook states.
        update: o((k) => {
          Hn(k).forEach((C) => {
            st(f, C) ? u(k[C], v[C], C) : C in a && be(w) && w({
              [C]: k[C]
            });
          });
        }),
        __proxyState: o((k) => st(f, k) && je(r[k], ot) ? (t.trackedKeys[k] = j, r[k]) : g(k)),
        /**
         * send and wait for responding with `await`
         * this is always used in `nuxt3`
         * @example
         * ```js
         * const { loading, data, error } = await useRequest(...);
         * ```
         */
        then(k) {
          Ge(m, (I) => {
            t.trackedKeys[I] = j;
          });
          const C = () => {
            Qt(R, "then"), k(R);
          };
          be(S) ? S(C) : C();
        }
      }, R = wt(a, x);
      return R;
    },
    /**
     * transform state proxies to object.
     * @param states proxy array of framework states
     * @param filterKey filter key of state proxy
     * @returns an object that contains the states of target form
     */
    objectify: (r, a) => r.reduce((v, m) => (v[m.k] = a ? m[a] : m, v), {}),
    transformState2Proxy: (r, a) => _e(hn, r, a, (v) => c(v, a, t), s, (v, m) => u(m, v, a))
  };
}
const os = Ct("useRequest"), Gn = Ct("useWatcher"), Kn = Ct("useFetcher"), Xn = (e) => ({
  [ke.USE_REQUEST]: os,
  [ke.USE_WATCHER]: Gn,
  [ke.USE_FETCHER]: Kn
})[e], Qn = (e, t) => e(je(t, Nn), "expected a method instance."), qt = "success", Bt = "error", Yt = "complete";
var ss = (e, t, n, s) => ({
  /** The method instance of the last request */
  m: U,
  /** sent method keys */
  rf: {},
  /** frontStates */
  fs: {},
  /** eventManager */
  em: n,
  /** hookType, useRequest=1, useWatcher=2, useFetcher=3 */
  ht: e,
  /** hook config */
  c: t,
  /** referingObject */
  ro: s,
  /** merged states */
  ms: {}
});
class Ae {
  constructor(t, n) {
    this.method = t, this.args = n;
  }
  clone() {
    return { ...this };
  }
  static spawn(t, n) {
    return _e(Ae, t, n);
  }
}
class is extends Ae {
  constructor(t, n, s) {
    super(t.method, t.args), this.data = n, this.fromCache = s;
  }
}
class rs extends Ae {
  constructor(t, n) {
    super(t.method, t.args), this.error = n;
  }
}
class gn extends Ae {
  constructor(t, n, s, o, c) {
    super(t.method, t.args), this.status = n, this.data = s, this.fromCache = n === "error" ? !1 : o, this.error = c;
  }
}
const as = (e, t) => t(), gt = {}, ls = (e, t) => {
  const n = gt[e] || {};
  return n[t] ? Array.from(n[t]) : [];
}, cs = (e, t, n) => {
  const s = gt[e] = gt[e] || {};
  s[t] || (s[t] = _e(Set)), s[t].add(n);
}, us = (e, t, n) => {
  const s = gt[e], o = s[t];
  s && o && (n ? o.delete(n) : o.clear(), o.size === 0 && Qt(s, t));
};
function Gt(e, t, n = []) {
  const s = Xn(e.ht);
  let o = An(t, s, n);
  const { fs: c, ht: u, c: p } = e, { loading: f, data: l, error: r } = c, a = u === ke.USE_FETCHER, { force: v = V, middleware: m = as } = p, w = Wn(o), { id: g } = w, S = We(o), { abortLast: x = j } = p, R = !e.m;
  return e.m = o, (async () => {
    let k = Re, C = V, I = Fn(U), E = Re, $ = Re;
    const M = await jt(o);
    let P = () => !!M, D = V;
    a || (cs(g, S, e), k = () => us(g, S, e));
    const z = (A) => {
      C = j;
      const { force: re = v, method: L = o } = A || {}, q = Bn(re, [
        _e(Ae, o, n)
      ]), Y = (Oe) => ({ loaded: Te, total: Ze }) => {
        c[Oe].v = {
          loaded: Te,
          total: Ze
        };
      };
      o = L, e.rf[S] = k, D || (f.v = !!q || !M);
      const { downloading: Ce, uploading: Ne } = e.ro.trackedKeys;
      return E = Ce ? o.onDownload(Y("downloading")) : E, $ = Ne ? o.onUpload(Y("uploading")) : $, I = o.send(q), P = () => o.fromCache || V, I;
    }, N = {
      method: o,
      cachedResponse: M,
      config: p,
      abort: () => o.abort()
    }, F = () => u !== ke.USE_WATCHER || !x || e.m === o, H = (A = j) => {
      A && R && (f.v = V), D = A;
    }, $e = m(a ? {
      ...N,
      args: n,
      fetch: (A, ...re) => (Qn(s, A), Gt(e, A, re)),
      proxyStates: qo(c, "data"),
      controlLoading: H
    } : {
      ...N,
      args: n,
      send: (...A) => Gt(e, t, A),
      proxyStates: c,
      controlLoading: H
    }, z);
    let ie = U;
    const K = Ae.spawn(o, n);
    try {
      const A = await $e, re = (L) => (a ? e.c.updateState !== V && Ge(ls(g, S), (q) => {
        q.fs.data.v = L;
      }) : F() && (l.v = L), F() && (r.v = U, !D && (f.v = V), e.em.emit(qt, _e(is, K, L, P())), e.em.emit(Yt, _e(gn, K, qt, L, P(), U))), L);
      ie = // When no data is returned or undefined is returned in the middleware, get the real response data
      // Otherwise, use the returned data and no longer wait for the response promise. At this time, you also need to call the response callback.
      A !== U ? re(A) : C ? (
        // There are two possibilities when middlewareCompletePromise is resolve
        // 1. The request is normal
        // 2. The request is incorrect, but the error is captured by the middleware function. At this time, the success callback will also be called, that is, afterSuccess(undefinedValue)
        await Xt(I, re, () => re(U))
      ) : (
        // If is next called is not called, no data is returned
        U
      ), !C && !D && (f.v = V);
    } catch (A) {
      throw F() && (r.v = A, !D && (f.v = V), e.em.emit(Bt, _e(rs, K, A)), e.em.emit(Yt, _e(gn, K, Bt, U, P(), A))), A;
    }
    return E(), $(), ie;
  })();
}
const _n = (e) => e.current;
function Zt(e, t, n, s, o = V, c, u = 0) {
  var p;
  n = { ...n };
  let f = !!o, l = U;
  if (o)
    try {
      const L = An(t, Xn(e)), q = Wn(L), Y = q.l1Cache.get(Xo(q.id, We(L)));
      if (Y && !je(Y, at)) {
        const [Ne, Oe] = Y;
        (!Oe || Oe > ht()) && (l = Ne);
      }
      f = !!Bn((p = n.force) !== null && p !== void 0 ? p : V) || !l;
    } catch {
    }
  const { create: r, effectRequest: a, ref: v, objectify: m, exposeProvider: w, transformState2Proxy: g, __referingObj: S } = Yn(zn(), n.__referingObj), x = {
    total: 0,
    loaded: 0
  }, { managedStates: R = {} } = n, k = ns(R, (L, q) => g(L, q)), C = r(l ?? (be(s) ? s() : s), "data"), I = r(f, "loading"), E = r(U, "error"), $ = r({ ...x }, "downloading"), M = r({ ...x }, "uploading"), P = m([C, I, E, $, M]), D = es(), z = _n(v(ss(e, n, D, S)));
  z.fs = P, z.em = D, z.c = n, z.ms = { ...P, ...k };
  const N = c !== U, F = (L = t, q) => Gt(z, L, q), H = v(U), $e = v(V), ie = _n(v(Yo())), K = (L = S, q) => {
    ie(() => {
      (!xo.ssr || H.current) && ($e.current = j, pt(ft(F(q), (Y) => {
        if (!L.bindError && !L.trackedKeys.error)
          throw Y;
      }), () => {
        H.current && H.current();
      }));
    });
  }, A = v(ts((L, q, Y) => K(q, Y), (L) => Se(L) ? vt(u) ? u[L] : u : 0));
  a({
    handler: (
      // When `watchingStates` is an array, it indicates the watching states (including an empty array). When it is undefined, it indicates the non-watching state.
      N ? (L) => A.current(L, S, t) : () => K(S)
    ),
    removeStates: () => {
      Ge(Vn(z.rf), (L) => L());
    },
    frontStates: { ...P, ...k },
    watchingStates: c,
    immediate: o ?? j
  });
  const re = w({
    ...m([C, I, E, $, M]),
    abort: () => z.m && z.m.abort(),
    /**
     * Manually initiate a request by executing this method
     * @param sendCallingArgs Parameters passed in when calling the send function
     * @param methodInstance method object
     * @param isFetcher Whether to call isFetcher
     * @returns Request promise
     */
    send: (L, q) => F(q, L),
    onSuccess(L) {
      D.on(qt, L);
    },
    onError(L) {
      S.bindError = j, D.on(Bt, L);
    },
    onComplete(L) {
      D.on(Yt, L);
    },
    /**
     * send and wait for responding with `await`
     * this is always used in `nuxt3` and `<suspense>` in vue3
     * @example
     * ```js
     * const { loading, data, error } = await useRequest(...);
     * ```
     */
    then(L) {
      const q = () => {
        L(re);
      }, { resolve: Y, promise: Ce } = qn();
      H.current = Y, Qe(() => {
        !$e.current && Y();
      }, 10), Xt(Ce, q, q);
    }
  });
  return re;
}
function ds(e = {}) {
  const t = Zt(ke.USE_FETCHER, Re, e), { send: n } = t;
  return Qt(t, "send"), wt(t, {
    /**
     * Fetch data fetch will definitely send a request, and if the currently requested data has a corresponding management state, this state will be updated.
     * @param matcher Method object
     */
    fetch: (s, ...o) => (Qn(Kn, s), n(o, s))
  });
}
function Je(e, t = {}) {
  const { immediate: n = j, initialData: s } = t, o = Zt(ke.USE_REQUEST, e, t, s, !!n), { send: c } = o;
  return wt(o, {
    send: (...u) => c(u)
  });
}
function fs(e, t, n = {}) {
  Gn(t && fe(t) > 0, "expected at least one watching state");
  const { immediate: s, debounce: o = 0, initialData: c } = n, u = Zt(
    ke.USE_WATCHER,
    e,
    n,
    c,
    !!s,
    // !!immediate means not send request immediately
    t,
    o
  ), { send: p } = u;
  return wt(u, {
    send: (...f) => p(f)
  });
}
var ps = (e) => {
  let t = {};
  return {
    snapshots: () => t,
    save(n, s = V) {
      const o = We(n);
      (!t[o] || s) && (t[o] = {
        entity: n
      });
    },
    get: (n) => t[We(je(n, Nn) ? n : e(n))],
    remove(n) {
      n ? delete t[n] : t = {};
    }
  };
};
const Fe = Ct("usePagination"), bn = (e, t) => Fe(Se(e) && e < fe(t), "index must be a number that less than list length"), yn = (e) => [
  e[e.length - 2],
  // refreshPage
  e[e.length - 1],
  // isRefresh
  e.slice(0, e.length - 2)
  // send args
];
var Jn = (e, t = {}) => {
  const { create: n, computed: s, ref: o, watch: c, exposeProvider: u, objectify: p, __referingObj: f } = Yn(zn()), { preloadPreviousPage: l = j, preloadNextPage: r = j, total: a = (b) => b.total, data: v = (b) => b.data, append: m = V, initialPage: w = 1, initialPageSize: g = 10, watchingStates: S = [], initialData: x, immediate: R = j, middleware: k, force: C = Re, actions: I = {}, ...E } = t, $ = o(e), M = o(V), P = n(w, "page"), D = n(g, "pageSize"), z = n(x ? v(x) || [] : [], "data"), N = n(x ? a(x) : U, "total"), { snapshots: F, get: H, save: $e, remove: ie } = o(ps((b) => $.current(b, D.v))).current, K = (b) => v(b) || b, A = ds({
    __referingObj: f,
    updateState: V,
    force: ({ args: b }) => b[fe(b) - 1]
  }), { loading: re, fetch: L, abort: q, onSuccess: Y } = A, Ce = o(re), Ne = (b = P.v, y = []) => {
    const T = e(b, D.v, ...y);
    return $e(T), T;
  };
  c(S, () => {
    P.v = w, M.current = j;
  });
  const Oe = o({}), Te = n("", "status"), Ze = n([], "removing"), $t = n(U, "replacing"), et = s(() => {
    const b = N.v;
    return b !== U ? Math.ceil(b / D.v) : U;
  }, [D, N], "pageCount"), tt = (b) => (...y) => Oe.current[b](...y), lt = fs((...b) => {
    const [y, , T] = yn(b);
    return Ne(y, T);
  }, [...S, P.e, D.e], {
    __referingObj: f,
    immediate: R,
    initialData: x,
    managedStates: p([z, P, D, N], "s"),
    middleware(b, y) {
      return k ? k({
        ...b,
        delegatingActions: {
          refresh: tt("refresh"),
          insert: tt("insert"),
          remove: tt("remove"),
          replace: tt("replace"),
          reload: tt("reload"),
          getState: (T) => ({
            page: P,
            pageSize: D,
            data: z,
            pageCount: et,
            total: N,
            // eslint-disable-next-line @typescript-eslint/no-use-before-define
            isLastPage: kt
          })[T].v
        }
      }, y) : y();
    },
    force: (b) => b.args[1] || (be(C) ? C(b) : C),
    ...E
  }), { send: ct } = lt, Et = lt.__proxyState("data"), tn = async (b) => {
    const { rawData: y = Et.v, preloadPage: T, fetchMethod: O, forceRequest: B = V, isNextPage: X = V } = b, te = et.v, ae = te ? T > te : X ? fe(K(y)) < D.v : V;
    if (!(T > 0 && !ae))
      return V;
    const { e: Z } = Bo(O), ge = await jt(O);
    return Z(At) <= ht() ? V : B || !ge;
  }, nn = async (b, y, T = []) => {
    const O = P.v + 1, B = Ne(O, T);
    r && await tn({
      rawData: b,
      preloadPage: O,
      fetchMethod: B,
      isNextPage: j,
      forceRequest: y
    }) && ft(L(B, ...T, y), Re);
  }, lo = async (b, y = []) => {
    const T = P.v - 1, O = Ne(T, y);
    l && await tn({
      rawData: b,
      preloadPage: T,
      fetchMethod: O
    }) && ft(L(O, ...y, U), Re);
  }, St = () => {
    const b = Et.v;
    if (!b)
      return j;
    const y = K(b), T = P.v, O = et.v, B = vt(y) ? fe(y) : 0;
    return O ? T >= O : B < D.v;
  }, kt = n(St(), "isLastPage");
  c([P, et, Et, D], async () => {
    Qe(() => {
      kt.v = St();
    });
  });
  const Tt = async () => {
    const b = H(P.v);
    b && await zt(b.entity, (y) => {
      if (y) {
        const T = K(y) || [];
        return Be(T, 0, fe(T), ...z.v), y;
      }
    });
  };
  Y(({ method: b, data: y }) => {
    const T = H(P.v);
    if (T && We(T.entity) === We(b)) {
      const O = K(y);
      if (m) {
        const B = z.v, X = D.v, te = fe(B) % X;
        if (te > 0) {
          const ae = [...z.v];
          Be(ae, (P.v - 1) * X, te, ...O), z.v = ae;
        }
      } else
        z.v = O;
    }
  });
  const Pt = o(U), Rt = o(U);
  lt.onSuccess(({ data: b, args: y, method: T }) => {
    const [O, B, X] = yn(y), { total: te } = H(T) || {}, ae = b;
    N.v = te !== U ? te : a(ae), B || (lo(ae, X), nn(ae, V, X));
    const Ue = D.v, Z = K(ae);
    if (Fe(vt(Z), "Got wrong array, did you return the correct array of list in `data` function"), m) {
      if (M.current && (z.v = []), O === U)
        z.v = [...z.v, ...Z];
      else if (O) {
        const ge = [...z.v];
        Be(ge, (O - 1) * Ue, Ue, ...Z), z.v = ge;
      }
    } else
      z.v = Z;
  }).onSuccess(({ data: b }) => {
    var y;
    (y = Pt.current) === null || y === void 0 || y.call(Pt, b);
  }).onError(({ error: b }) => {
    var y;
    (y = Rt.current) === null || y === void 0 || y.call(Rt, b);
  }).onComplete(() => {
    M.current = V;
  });
  const ut = (b) => {
    const y = z.v.indexOf(b);
    return Fe(y >= 0, "item is not found in list"), y;
  }, { addQueue: Lt, onComplete: on } = o(Go()).current, It = async (b = P.v) => {
    let y = b, T = Fn();
    if (m) {
      if (!Se(b)) {
        const O = ut(b);
        y = Math.floor(O / D.v) + 1;
      }
      Fe(y <= P.v, "refresh page can't greater than page"), T = ct(y, j);
    } else
      Fe(Se(y), "unable to calculate refresh page by item in pagination mode"), T = y === P.v ? ct(U, j) : L(e(y, D.v), j);
    return T;
  }, sn = async (b = V) => {
    const y = P.v, T = F();
    let O = Vn(T);
    if (b)
      ie();
    else {
      const B = He(mt([H(y - 1), H(y), H(y + 1)], Boolean), ({ entity: X }) => We(X));
      O = He(mt(Hn(T), (X) => !st(B, X)), (X) => {
        const te = T[X];
        return delete T[X], te;
      });
    }
    await $o(He(O, ({ entity: B }) => B));
  }, rn = async () => {
    Ce.current && q(), await sn();
    const b = H(P.v + 1);
    if (b) {
      const y = K(await jt(b.entity) || {}) || [];
      nn(U, fe(y) < D.v);
    }
  }, an = (b) => {
    if (b === 0)
      return;
    const y = N.v;
    if (Se(y)) {
      const T = Math.max(y + b, 0);
      N.v = T;
      const O = P.v;
      Ge([H(O - 1), H(O), H(O + 1)], (B) => {
        B && (B.total = T);
      });
    }
  }, ln = (b, y = 0) => (on(rn), Lt(async () => {
    const T = Se(y) ? y : ut(y) + 1;
    Fe(T >= 0, "illegal insert position"), be(I.insert) && (Te.v = "inserting", await pt(I.insert(b, y), () => {
      Te.v = "";
    }));
    let O = U;
    const B = [...z.v];
    if (fe(B) % D.v === 0 && (O = B.pop()), Be(B, T, 0, b), z.v = B, an(1), await Tt(), O) {
      const X = H(P.v + 1);
      X && await zt(X.entity, (te) => {
        if (te) {
          const ae = K(te) || [];
          return ae.unshift(O), ae.pop(), te;
        }
      });
    }
  })), cn = (...b) => (on(rn), Lt(async () => {
    const y = He(b, (Z) => {
      const ge = Se(Z) ? Z : ut(Z);
      return bn(ge, z.v), ge;
    });
    if (be(I.remove)) {
      Te.v = "removing", Ze.v = [...y];
      const Z = No(He(b, (ge) => I.remove(ge)));
      await pt(Z, () => {
        Te.v = "", Ze.v = [];
      });
    }
    const T = P.v, O = T + 1, B = H(O), X = [];
    B && await zt(B.entity, (Z) => {
      if (Z) {
        const ge = K(Z);
        return vt(ge) && Ke(X, ...Be(ge, 0, fe(y))), Z;
      }
    });
    const te = St(), ae = fe(X);
    let Ue = !1;
    if (ae > 0 || te) {
      const Z = mt(z.v, (ge, co) => !st(y, co));
      Ue = !m && te && fe(Z) <= 0, !Ue && ae > 0 && Ke(Z, ...X), z.v = Z;
    } else ae <= 0 && !te && It(T);
    return an(-fe(y)), Tt().then(() => {
      Ue && (P.v = T - 1);
    });
  })), un = (b, y) => Lt(async () => {
    Fe(y !== U, "expect specify the replace position");
    const T = Se(y) ? y : ut(y);
    bn(T, z.v), be(I.replace) && (Te.v = "replacing", $t.v = T, await pt(I.replace(b, y), () => {
      Te.v = "", $t.v = U;
    }));
    const O = [...z.v];
    Be(O, T, 1, b), z.v = O, await Tt();
  }), dn = async () => {
    await sn(j), M.current = j, P.v === w ? ft(ct(), Re) : P.v = w;
    const { resolve: b, reject: y, promise: T } = qn();
    return Pt.current = b, Rt.current = y, T;
  };
  return Oe.current = {
    refresh: It,
    insert: ln,
    remove: cn,
    replace: un,
    reload: dn
  }, u({
    ...lt,
    ...p([z, P, et, D, N, kt, Te, Ze, $t]),
    send: (...b) => ct(...b, U, U),
    fetching: A.loading,
    onFetchSuccess: A.onSuccess,
    onFetchError: A.onError,
    onFetchComplete: A.onComplete,
    refresh: It,
    insert: ln,
    remove: cn,
    replace: un,
    reload: dn
  });
}, wn;
(function(e) {
  e[e.CONNECTING = 0] = "CONNECTING", e[e.OPEN = 1] = "OPEN", e[e.CLOSED = 2] = "CLOSED";
})(wn || (wn = {}));
var Cn;
(function(e) {
  e.Open = "open", e.Error = "error", e.Message = "message";
})(Cn || (Cn = {}));
var ms = typeof global == "object" && global && global.Object === Object && global, vs = typeof self == "object" && self && self.Object === Object && self, Zn = ms || vs || Function("return this")(), _t = Zn.Symbol, eo = Object.prototype, hs = eo.hasOwnProperty, gs = eo.toString, nt = _t ? _t.toStringTag : void 0;
function _s(e) {
  var t = hs.call(e, nt), n = e[nt];
  try {
    e[nt] = void 0;
    var s = !0;
  } catch {
  }
  var o = gs.call(e);
  return s && (t ? e[nt] = n : delete e[nt]), o;
}
var bs = Object.prototype, ys = bs.toString;
function ws(e) {
  return ys.call(e);
}
var Cs = "[object Null]", xs = "[object Undefined]", xn = _t ? _t.toStringTag : void 0;
function $s(e) {
  return e == null ? e === void 0 ? xs : Cs : xn && xn in Object(e) ? _s(e) : ws(e);
}
function Es(e) {
  return e != null && typeof e == "object";
}
var Ss = "[object Symbol]";
function ks(e) {
  return typeof e == "symbol" || Es(e) && $s(e) == Ss;
}
var Ts = /\s/;
function Ps(e) {
  for (var t = e.length; t-- && Ts.test(e.charAt(t)); )
    ;
  return t;
}
var Rs = /^\s+/;
function Ls(e) {
  return e && e.slice(0, Ps(e) + 1).replace(Rs, "");
}
function bt(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var $n = NaN, Is = /^[-+]0x[0-9a-f]+$/i, Ms = /^0b[01]+$/i, Ds = /^0o[0-7]+$/i, zs = parseInt;
function it(e) {
  if (typeof e == "number")
    return e;
  if (ks(e))
    return $n;
  if (bt(e)) {
    var t = typeof e.valueOf == "function" ? e.valueOf() : e;
    e = bt(t) ? t + "" : t;
  }
  if (typeof e != "string")
    return e === 0 ? e : +e;
  e = Ls(e);
  var n = Ms.test(e);
  return n || Ds.test(e) ? zs(e.slice(2), n ? 2 : 8) : Is.test(e) ? $n : +e;
}
function Ns(e, t, n) {
  return e === e && (n !== void 0 && (e = e <= n ? e : n), t !== void 0 && (e = e >= t ? e : t)), e;
}
function dt(e, t, n) {
  return n === void 0 && (n = t, t = void 0), n !== void 0 && (n = it(n), n = n === n ? n : 0), t !== void 0 && (t = it(t), t = t === t ? t : 0), Ns(it(e), t, n);
}
var Ot = function() {
  return Zn.Date.now();
}, Os = "Expected a function", Us = Math.max, Fs = Math.min;
function to(e, t, n) {
  var s, o, c, u, p, f, l = 0, r = !1, a = !1, v = !0;
  if (typeof e != "function")
    throw new TypeError(Os);
  t = it(t) || 0, bt(n) && (r = !!n.leading, a = "maxWait" in n, c = a ? Us(it(n.maxWait) || 0, t) : c, v = "trailing" in n ? !!n.trailing : v);
  function m(E) {
    var $ = s, M = o;
    return s = o = void 0, l = E, u = e.apply(M, $), u;
  }
  function w(E) {
    return l = E, p = setTimeout(x, t), r ? m(E) : u;
  }
  function g(E) {
    var $ = E - f, M = E - l, P = t - $;
    return a ? Fs(P, c - M) : P;
  }
  function S(E) {
    var $ = E - f, M = E - l;
    return f === void 0 || $ >= t || $ < 0 || a && M >= c;
  }
  function x() {
    var E = Ot();
    if (S(E))
      return R(E);
    p = setTimeout(x, g(E));
  }
  function R(E) {
    return p = void 0, v && s ? m(E) : (s = o = void 0, u);
  }
  function k() {
    p !== void 0 && clearTimeout(p), l = 0, s = f = o = p = void 0;
  }
  function C() {
    return p === void 0 ? u : R(Ot());
  }
  function I() {
    var E = Ot(), $ = S(E);
    if (s = arguments, o = this, f = E, $) {
      if (p === void 0)
        return w(f);
      if (a)
        return clearTimeout(p), p = setTimeout(x, t), m(f);
    }
    return p === void 0 && (p = setTimeout(x, t)), u;
  }
  return I.cancel = k, I.flush = C, I;
}
var Hs = "Expected a function";
function no(e, t, n) {
  var s = !0, o = !0;
  if (typeof e != "function")
    throw new TypeError(Hs);
  return bt(n) && (s = "leading" in n ? !!n.leading : s, o = "trailing" in n ? !!n.trailing : o), to(e, t, {
    leading: s,
    maxWait: t,
    trailing: o
  });
}
var Vs = Object.defineProperty, js = Object.defineProperties, Ws = Object.getOwnPropertyDescriptors, En = Object.getOwnPropertySymbols, As = Object.prototype.hasOwnProperty, qs = Object.prototype.propertyIsEnumerable, Sn = (e, t, n) => t in e ? Vs(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, yt = (e, t) => {
  for (var n in t || (t = {}))
    As.call(t, n) && Sn(e, n, t[n]);
  if (En)
    for (var n of En(t))
      qs.call(t, n) && Sn(e, n, t[n]);
  return e;
}, oo = (e, t) => js(e, Ws(t));
const Bs = ["onPointerdown"], Ys = {
  name: "ScrollbarThumb"
};
function Gs(e, { expose: t }) {
  const n = e;
  mo(($) => ({
    "1fb98f78": d(s)
  }));
  const s = le(() => {
    var $;
    return `${($ = n.thumbWidth) != null ? $ : 12}px`;
  });
  let o = null, c = Pe(null);
  const u = { pageX: 0, pageY: 0, scrollPos: 0 };
  let p = null;
  const f = () => {
    o = setTimeout(() => {
      c.value && c.value.classList.remove("scrollbar__thumbPlaceholder--scrolling"), o = null;
    }, n.autoHideDelay);
  }, l = () => {
    o !== null && clearTimeout(o);
  };
  Ye(l);
  const r = no(($) => {
    $.stopPropagation(), $.preventDefault();
    const M = n.type === "horizontal" ? "pageX" : "pageY", P = ($[M] - u[M]) / n.scrollInfo.wrapperMainSize * n.scrollInfo.contentMainSize;
    n.wrapperEl.scrollTo({ [n.type === "horizontal" ? "left" : "top"]: u.scrollPos + P, behavior: "auto" });
  }, 16), a = () => {
    f(), c.value.removeEventListener("pointermove", r), c.value.removeEventListener("pointerup", a), c.value.removeEventListener("pointercancel", a), c.value.removeEventListener("mousewheel", a), document.removeEventListener("mousewheel", a), typeof p == "number" && c.value.releasePointerCapture(p), p = null;
  }, v = ($) => {
    $.ctrlKey || $.button !== 0 || (l(), u.pageX = $.pageX, u.pageY = $.pageY, u.scrollPos = n.wrapperEl[n.type === "horizontal" ? "scrollLeft" : "scrollTop"], p = $ == null ? void 0 : $.pointerId, c.value.setPointerCapture(p), c.value.addEventListener("pointermove", r), c.value.addEventListener("pointerup", a), c.value.addEventListener("pointercancel", a), c.value.addEventListener("mousewheel", a, { passive: !1 }), document.addEventListener("mousewheel", a, { passive: !1 }), c.value.classList.add("scrollbar__thumbPlaceholder--scrolling"));
  };
  t({
    autoHideAfterScroll: () => {
      l(), c.value && c.value.classList.add("scrollbar__thumbPlaceholder--scrolling"), f();
    }
  });
  let w = Pe(!1), g = Pe(!1), S = Pe(null), x = null, R = null, k = le(() => n.fixedThumb && !g.value);
  const C = ([$]) => g.value = $.isIntersecting, I = ([$]) => w.value = $.isIntersecting, E = () => {
    x && (x.disconnect(), x = null), R && (R.disconnect(), R = null);
  };
  return Ee(() => [n.fixedThumb, n.wrapperEl], () => {
    if (!n.fixedThumb || !n.wrapperEl)
      return E();
    E(), R = new IntersectionObserver(I, { threshold: [0, 0.5] }), R.observe(n.wrapperEl), x = new IntersectionObserver(C), x.observe(S.value);
  }), Ye(E), ($, M) => (h(), _(ce, null, [
    G(i("div", {
      class: ye([
        "scrollbar__thumbPlaceholder",
        `scrollbar__thumbPlaceholder--${e.type}`,
        {
          "scrollbar__thumbPlaceholder--autoHide": e.autoHide,
          "scrollbar__thumbPlaceholder--autoExpand": e.autoExpand
        }
      ]),
      style: ze({
        width: e.type === "horizontal" ? `${e.scrollInfo.thumbSize}px` : "",
        height: e.type === "vertical" ? `${e.scrollInfo.thumbSize}px` : "",
        position: k.value ? "fixed" : "absolute",
        [e.type === "vertical" ? "top" : "left"]: k.value ? `${e.scrollInfo.boundaryDistance + 3}px` : "3px"
      }),
      ref: (P, D) => {
        D.thumbEl = P, c.value = P;
      },
      onPointerdown: rt(v, ["stop"])
    }, [
      M[0] || (fn(-1), M[0] = i("div", {
        class: ye(["scrollbar__thumb", `scrollbar__thumb--${e.type}`])
      }, null, 2), fn(1), M[0])
    ], 46, Bs), [
      [pn, !!e.scrollInfo.thumbSize && (e.fixedThumb ? w.value : !0)]
    ]),
    n.fixedThumb ? G((h(), _("div", {
      key: 0,
      ref: (P, D) => {
        D.shepherdEl = P, S.value = P;
      },
      class: ye(["scrollbar__shepherd", `scrollbar__shepherd--${e.type}`])
    }, null, 2)), [
      [pn, !!e.scrollInfo.thumbSize]
    ]) : Q("", !0)
  ], 64));
}
const Ks = /* @__PURE__ */ Ln(oo(yt({}, Ys), {
  props: {
    type: null,
    autoExpand: null,
    autoHide: null,
    autoHideDelay: null,
    fixedThumb: null,
    scrollInfo: null,
    thumbWidth: null,
    wrapperEl: null
  },
  setup: Gs
})), Xs = {
  wait: 333,
  type: "debounce"
};
function kn(...e) {
  const t = "value" in (e == null ? void 0 : e[0]);
  let n;
  t ? n = e == null ? void 0 : e[1] : n = e == null ? void 0 : e[0];
  const { wait: s, type: o, callback: c } = yt(yt({}, Xs), n), u = t ? e[0] : Pe(null), p = po({ left: 0, top: 0, right: 0, bottom: 0, width: 0, height: 0, x: 0, y: 0 }), f = () => {
    const v = u.value.getBoundingClientRect();
    p.left = v.left, p.top = v.top, p.right = v.right, p.bottom = v.bottom, p.width = v.width, p.height = v.height, p.x = v.x, p.y = v.y, c == null || c();
  };
  let l = null, r = null;
  const a = () => {
    l && window.removeEventListener("resize", l), r && (r.disconnect(), r = null);
  };
  return Mn(() => {
    u.value && (a(), l = f, o === "throttle" && s >= 4 ? l = no(l, s) : o === "debounce" && s >= 4 && (l = to(l, s)), window.addEventListener("resize", l), r = new ResizeObserver(l), r.observe(u.value));
  }), Ye(a), t ? p : [u, p];
}
const Qs = {
  name: "CustomScrollbar",
  inheritAttrs: !1
};
function Js(e, { expose: t, emit: n }) {
  const s = e, o = {
    horizontal: { el: null, instance: null },
    vertical: { el: null, instance: null }
  }, c = (C, I) => {
    o[I].instance || (o[I].instance = C);
  };
  let u = Pe(null), p = Pe(null);
  Le(() => {
    var C;
    const I = Array.from((C = u.value.parentElement) == null ? void 0 : C.childNodes);
    for (const E in o)
      o[E].el = I.find(($) => {
        var M;
        return (M = $ == null ? void 0 : $.classList) == null ? void 0 : M.contains(`scrollbar__thumbPlaceholder--${E}`);
      });
  });
  const f = kn(u, { wait: s.throttleWait, type: s.throttleType, callback: v }), l = kn(p, { wait: s.throttleWait, type: s.throttleType, callback: v });
  let r = Pe(0), a = Pe(0);
  function v() {
    r.value = Math.max(u.value.scrollHeight - f.height | 0, 0), a.value = Math.max(u.value.scrollWidth - f.width | 0, 0);
  }
  let m = le(() => ({
    thumbSize: a.value ? dt(f.width / u.value.scrollWidth * f.width, s.thumbMinSize > f.width ? 48 : s.thumbMinSize, s.thumbMaxSize) : 0,
    contentMainSize: l.width,
    wrapperMainSize: f.width,
    boundaryDistance: Math.abs(f.left)
  })), w = le(() => ({
    thumbSize: r.value ? dt(f.height / u.value.scrollHeight * f.height, s.thumbMinSize > f.height ? 48 : s.thumbMinSize, s.thumbMaxSize) : 0,
    contentMainSize: l.height,
    wrapperMainSize: f.height,
    boundaryDistance: Math.abs(f.top)
  })), g = le(() => f.height - w.value.thumbSize - 5), S = le(() => f.width - m.value.thumbSize - 5);
  const x = () => {
    a.value && (o.horizontal.el.style.transform = `translate3d(${u.value.scrollLeft / a.value * S.value}px, 0, 0)`, o.horizontal.instance.autoHideAfterScroll()), r.value && (o.vertical.el.style.transform = `translate3d(0, ${u.value.scrollTop / r.value * g.value}px, 0)`, o.vertical.instance.autoHideAfterScroll());
  };
  Ee(() => [a.value, r.value], x);
  const R = (C) => {
    C.stopPropagation();
    const I = u.value.scrollLeft, E = u.value.scrollTop, $ = dt(I + ((C == null ? void 0 : C.deltaX) || 0), 0, a.value) | 0, M = dt(E + ((C == null ? void 0 : C.deltaY) || 0), 0, r.value) | 0;
    u.value.scrollLeft = $, u.value.scrollTop = M, a.value && (o.horizontal.el.style.transform = `translate3d(${$ / a.value * S.value}px, 0, 0)`, o.horizontal.instance.autoHideAfterScroll()), r.value && (o.vertical.el.style.transform = `translate3d(0, ${M / r.value * g.value}px, 0)`, o.vertical.instance.autoHideAfterScroll()), n("scroll", { target: u.value, scrollLeft: $, scrollTop: M });
  }, k = (C) => {
    s.simulateScroll ? R(C) : x();
  };
  return Ee(f, () => n("wrapperResize", f)), Ee(l, () => n("contentResize", l)), t({
    scrollEl: u
  }), (C, I) => (h(), _("div", {
    class: ye(["scrollbar__wrapper", e.wrapperClass]),
    style: ze(e.wrapperStyle)
  }, [
    i("div", fo({
      ref: (E, $) => {
        $.wrapperEl = E, u.value = E;
      },
      class: "scrollbar__scroller"
    }, C.$attrs, {
      onWheel: k,
      onScroll: k
    }), [
      i("div", {
        ref: (E, $) => {
          $.contentEl = E, p.value = E;
        },
        class: ye(["scrollbar__content", e.contentClass, { "scrollbar__content--fixedThumb": e.fixedThumb, [`scrollbar__content--${e.direction}`]: e.direction }]),
        style: ze(e.contentStyle)
      }, [
        In(C.$slots, "default")
      ], 6)
    ], 16),
    (h(), _(ce, null, qe(o, (E, $) => oe(Ks, {
      ref: (M) => c(M, $),
      key: $,
      autoExpand: e.autoExpand,
      autoHide: e.autoHide,
      autoHideDelay: e.autoHideDelay,
      fixedThumb: $ === e.direction ? !1 : e.fixedThumb,
      type: $,
      scrollInfo: $ === "vertical" ? w.value : m.value,
      thumbWidth: e.thumbWidth,
      wrapperEl: u.value
    }, null, 8, ["autoExpand", "autoHide", "autoHideDelay", "fixedThumb", "type", "scrollInfo", "thumbWidth", "wrapperEl"])), 64))
  ], 6));
}
const Ie = /* @__PURE__ */ Ln(oo(yt({}, Qs), {
  props: {
    wrapperClass: null,
    wrapperStyle: null,
    contentClass: null,
    contentStyle: null,
    direction: { default: "vertical" },
    thumbMinSize: { default: 48 },
    thumbMaxSize: { default: 1 / 0 },
    thumbWidth: { default: 12 },
    autoHide: { default: !0 },
    autoHideDelay: { default: 900 },
    autoExpand: { default: !0 },
    fixedThumb: null,
    throttleType: { default: "debounce" },
    throttleWait: { default: 333 },
    simulateScroll: null
  },
  emits: ["wrapperResize", "contentResize", "scroll"],
  setup: Js
})), Zs = (e) => Vo(e) || Ao(e);
function ei() {
  return (e, t) => {
    const n = t.config, s = n.timeout || 0, o = new AbortController(), { data: c, headers: u } = e, p = /content-type/i.test(Xe.keys(u).join()), f = c && c.toString() === "[object FormData]";
    !p && !f && (u["Content-Type"] = "application/json;charset=UTF-8");
    const l = fetch(e.url, {
      ...n,
      method: e.type,
      signal: o.signal,
      body: Zs(c) ? c : Oo(c)
    });
    let r, a = V;
    return s > 0 && (r = Qe(() => {
      a = j, o.abort();
    }, s)), {
      response: () => l.then((v) => (Wt(r), v.clone()), (v) => Do(a ? _e(Error, "fetchError: network timeout") : v)),
      // The then in the Headers function needs to catch exceptions, otherwise the correct error object will not be obtained internally.
      headers: () => l.then(({ headers: v }) => v, () => ({})),
      // Due to limitations of the node fetch library, this code cannot be unit tested, but it has passed the test in the browser.
      /* c8 ignore start */
      onDownload: async (v) => {
        let m = V;
        const w = await l.catch(() => {
          m = j;
        });
        if (!w)
          return;
        const { headers: g, body: S } = w.clone(), x = S ? S.getReader() : U, R = Number(g.get("Content-Length") || g.get("content-length") || 0);
        if (R <= 0)
          return;
        let k = 0;
        if (x) {
          const C = () => x.read().then(({ done: I, value: E = new Uint8Array() }) => {
            if (I || m)
              m && v(k, 0);
            else
              return k += E.byteLength, v(k, R), C();
          });
          C();
        }
      },
      onUpload() {
        console.error("fetch API does'nt support uploading progress. please consider to change `@alova/adapter-xhr` or `@alova/adapter-axios`");
      },
      /* c8 ignore stop */
      abort: () => {
        o.abort(), Wt(r);
      }
    };
  };
}
var ti = {
  name: "Vue",
  create: (e) => J(e),
  dehydrate: (e) => e.value,
  update: (e, t) => {
    t.value = e;
  },
  effectRequest({ handler: e, removeStates: t, immediate: n, watchingStates: s }) {
    Mt() && Ye(t), n && e(), Ge(s || [], (o, c) => {
      Ee(o, () => {
        e(c);
      }, { deep: j });
    });
  },
  computed: (e) => le(e),
  watch: (e, t) => {
    Ee(e, t, {
      deep: j
    });
  },
  onMounted: (e) => {
    Mt() ? Le(e) : Qe(e, 10);
  },
  onUnmounted: (e) => {
    Mt() && Ye(e);
  }
};
const xe = Eo({
  baseURL: Un(),
  requestAdapter: ei(),
  statesHook: ti,
  cacheFor: null,
  beforeRequest(e) {
    e.config.headers["Content-Type"] = "application/json", e.config.headers.authorization = `Bearer ${Kt()}`;
  },
  responded: async (e) => {
    if (e.status !== 200)
      throw new Error(`[${e.status}]${e.statusText}`);
    const t = await e.json();
    if (t.code !== "200") {
      t.code === "10001003" && Lo(t);
      const n = new Error(`[${t.code}]${t.message}`);
      throw n.response = t, n;
    }
    return t.result;
  }
});
function ni() {
  return xe.Get("/api/station/user/getUserInfo/v2").send(!0);
}
function oi(e) {
  return xe.Get("/api/station/point/getPointDetailPageListNew", { params: e });
}
function si(e) {
  return xe.Get("/api/station/point/tasks", { params: e, transform: (t) => t.pointEventList || [] });
}
function ii(e) {
  return xe.Get("/api/station/point/tasksNew", { params: e, transform: (t) => t.pointEventList || [] });
}
function ri(e) {
  return xe.Post("/api/station/point/task/do", e);
}
function ai(e) {
  return xe.Get("/api/station/point/getProductsNew", { params: e, transform: (t) => t.pointProductRespList || [] });
}
function li(e) {
  return xe.Get("/api/station/point/getAllProducts", { params: e, transform: (t) => t.pointProductRespList || [] });
}
function so(e) {
  return xe.Post("/api/station/point/exchangeProductNew", e);
}
function ci(e) {
  return xe.Get("/api/station/point/exchangeProductHistory", { params: e });
}
async function ui(e) {
  return await xe.Get(`/api/station/point/getPointProductUrl/${e}`);
}
function di(e) {
  return xe.Post("/api/station/user/subscribe", e);
}
function fi(e) {
  return xe.Post("/api/station/user/subscribePhone", e);
}
const se = (e, t) => {
  const n = e.__vccOpts || e;
  for (const [s, o] of t)
    n[s] = o;
  return n;
}, pi = {}, mi = { class: "list" };
function vi(e, t) {
  return h(), _("ul", mi, [...t[0] || (t[0] = [
    vo('<li class="redeem-item skeletonCard skeletonCard--shine"><div class="info"><div class="title skeletonText skeletonText--long"></div><div class="date skeletonText"></div></div><div class="count skeletonText skeletonText--short"></div></li><li class="line"></li><li class="redeem-item skeletonCard skeletonCard--shine"><div class="info"><div class="title skeletonText skeletonText--long"></div><div class="date skeletonText"></div></div><div class="count skeletonText skeletonText--short"></div></li>', 3)
  ])]);
}
const xt = /* @__PURE__ */ se(pi, [["render", vi]]), hi = {
  key: 0,
  class: "redeem-toast"
}, gi = { class: "msg" }, _i = {
  __name: "Toast",
  props: {
    teleportTarget: {
      type: String,
      default: "#lute-redeem-app-page"
    },
    icon: {
      type: String,
      default: "icon-circletick"
    },
    message: {
      type: String,
      required: !0
    },
    duration: {
      type: Number,
      default: 2e3
    },
    onClose: {
      type: Function,
      default: () => {
      }
    }
  },
  setup(e) {
    const t = e, n = J(!1);
    return Le(() => {
      n.value = !0, setTimeout(() => {
        n.value = !1, setTimeout(() => {
          t.onClose();
        }, 300);
      }, t.duration);
    }), (s, o) => (h(), me(ho, { to: e.teleportTarget }, [
      oe(Ht, { name: "toast-fade" }, {
        default: ve(() => [
          n.value ? (h(), _("div", hi, [
            i("i", {
              class: ye(["lutefont", e.icon])
            }, null, 2),
            i("div", gi, W(e.message), 1)
          ])) : Q("", !0)
        ]),
        _: 1
      })
    ], 8, ["to"]));
  }
};
let Me = null;
function ue(e) {
  Me && (document.body.removeChild(Me.el), Me = null), typeof e == "string" && (e = { message: e });
  const t = document.createElement("div"), n = () => {
    e.onClose && e.onClose(), mn(null, t), document.body.removeChild(t), Me = null;
  }, s = oe(_i, {
    ...e,
    onClose: n
  });
  return mn(s, t), document.body.appendChild(t), Me = {
    el: t,
    close: n
  }, Me;
}
ue.close = () => {
  Me && Me.close();
};
const De = {};
function bi(e, t) {
  return De[e] === void 0 && (De[e] = []), De[e] = [...De[e], t], function() {
    De[e] = De[e].filter((s) => s !== t);
  };
}
function io(e, t) {
  De[e] && De[e].forEach((n) => {
    n();
  });
}
function yi() {
  window.T4SThemeSP.Drawer.opend(window.$("#t4s-mini_cart"));
}
const Ve = Un(), en = `${Ve}/login?redirect=${encodeURIComponent(`${window.location.href}?lt-redeem=true`)}`, wi = { class: "redeem-list" }, Ci = { class: "header" }, xi = { class: "ctx" }, $i = ["href"], Ei = {
  key: 1,
  class: "balance"
}, Si = {
  key: 1,
  class: "list"
}, ki = ["onClick"], Ti = { class: "info" }, Pi = { class: "title" }, Ri = { class: "date" }, Li = {
  key: 0,
  class: "operate"
}, Ii = {
  key: 0,
  class: "lutefont icon-circletick"
}, Mi = {
  key: 0,
  class: "btn loading loading-btn"
}, Di = {
  key: 0,
  class: "icon lutefont icon-loading"
}, zi = {
  key: 0,
  class: "loading"
}, Ni = {
  key: 1,
  class: "lutefont icon-arrow"
}, Oi = /* @__PURE__ */ Object.assign({
  name: "Coins"
}, {
  __name: "Coins",
  setup(e) {
    const t = he(), n = de(), { userinfo: s } = ne(n), o = le(() => s.value ? si : ii), { loading: c, data: u, send: p } = Je(() => o.value({ completionStatus: 2 }), { initialData: [] });
    bi("update:task:list", p);
    async function f(l) {
      if (!s.value) {
        window.location.href = Ve;
        return;
      }
      l.type === 23 ? t.setComp("email", l) : l.type === 28 ? t.setComp("sms", l) : [24, 25, 26, 27].includes(l.type) ? (ri({ eventType: +l.type }).then(() => {
        p(), n.updateUserinfo();
      }), window.open(l.jumpLink, "_blank")) : l.type === 29 ? yi() : l.type === 22 ? window.open(`${Ve}?dialog=baby`, "_blank") : l.type === 21 ? window.open(`${Ve}?dialog=user`, "_blank") : window.open(Ve, "_blank");
    }
    return (l, r) => {
      var v;
      const a = we("track");
      return h(), _("div", wi, [
        i("div", Ci, [
          i("i", {
            class: "lutefont icon-arrow-left",
            onClick: r[0] || (r[0] = (...m) => d(t).back && d(t).back(...m))
          }),
          r[2] || (r[2] = i("h2", null, "Earn CozyCoins", -1)),
          i("i", {
            class: "lutefont icon-close",
            onClick: r[1] || (r[1] = (...m) => d(t).toggle && d(t).toggle(...m))
          })
        ]),
        i("div", xi, [
          d(s) ? (h(), _("div", Ei, [
            r[4] || (r[4] = ee(" My CozyCoins: ", -1)),
            i("strong", null, W((v = d(s)) == null ? void 0 : v.points), 1)
          ])) : G((h(), _("a", {
            key: 0,
            href: d(en),
            class: "balance link"
          }, [...r[3] || (r[3] = [
            i("strong", null, "Log In >", -1)
          ])], 8, $i)), [
            [a, { from: "coins" }, "login"]
          ]),
          oe(d(Ie), { "wrapper-class": "list-wrapper" }, {
            default: ve(() => [
              d(c) ? (h(), me(xt, { key: 0 })) : (h(), _("ul", Si, [
                (h(!0), _(ce, null, qe(d(u), (m) => (h(), _(ce, {
                  key: m.title
                }, [
                  G((h(), _("li", {
                    class: ye(["redeem-item", { completed: m.completionStatus === 1 }]),
                    onClick: rt((w) => f(m), ["stop"])
                  }, [
                    r[7] || (r[7] = i("div", { class: "icon" }, [
                      i("i", { class: "lutefont icon-gift" })
                    ], -1)),
                    i("div", Ti, [
                      i("div", Pi, W(m.title), 1),
                      i("div", Ri, W(m.type === 29 ? m.desc : `${m.pointsDesc} CozyCoins`), 1)
                    ]),
                    d(s) ? (h(), _("div", Li, [
                      m.completionStatus === 1 ? (h(), _("i", Ii)) : (h(), _(ce, { key: 1 }, [
                        m.type === 23 || m.type === 28 ? (h(), _("button", Mi, [
                          m.loading ? (h(), _("i", Di)) : Q("", !0),
                          r[5] || (r[5] = ee(" Set ", -1))
                        ])) : (h(), _(ce, { key: 1 }, [
                          m.loading ? (h(), _("div", zi, [...r[6] || (r[6] = [
                            i("i", { class: "icon lutefont icon-loading" }, null, -1)
                          ])])) : (h(), _("i", Ni))
                        ], 64))
                      ], 64))
                    ])) : Q("", !0)
                  ], 10, ki)), [
                    [a, { type: m.type, item: m.title, completed: m.completionStatus }, "task"]
                  ]),
                  r[8] || (r[8] = i("li", { class: "line" }, null, -1))
                ], 64))), 128))
              ]))
            ]),
            _: 1
          })
        ])
      ]);
    };
  }
}), Ui = /* @__PURE__ */ se(Oi, [["__scopeId", "data-v-b810b5c4"]]), Ut = {
  mounted(e, t) {
    let n = null, s = 0, o = 400;
    const c = (l) => l >= 2500 ? 100 : 300 - 200 * (l / 2500), u = () => {
      var r, a;
      typeof ((r = t.value) == null ? void 0 : r.handler) == "function" && t.value.handler((a = t.value) == null ? void 0 : a.arg);
      const l = Date.now() - s;
      o = c(l), n = setTimeout(u, o);
    }, p = () => {
      var l, r;
      n || (typeof ((l = t.value) == null ? void 0 : l.handler) == "function" && t.value.handler((r = t.value) == null ? void 0 : r.arg), s = Date.now(), o = 400, n = setTimeout(u, o));
    }, f = () => {
      n && (clearTimeout(n), n = null), s = 0, o = 400;
    };
    e.__longpressStart__ = p, e.__longpressCancel__ = f, e.addEventListener("mousedown", p), e.addEventListener("touchstart", p), e.addEventListener("mouseup", f), e.addEventListener("mouseleave", f), e.addEventListener("touchend", f);
  },
  beforeUnmount(e) {
    e.removeEventListener("mousedown", e.__longpressStart__), e.removeEventListener("touchstart", e.__longpressStart__), e.removeEventListener("mouseup", e.__longpressCancel__), e.removeEventListener("mouseleave", e.__longpressCancel__), e.removeEventListener("touchend", e.__longpressCancel__), e.__longpressStart__ = null, e.__longpressCancel__ = null;
  }
}, Fi = { class: "number-input" }, Hi = ["disabled"], Vi = ["placeholder", "min", "max", "step"], ji = ["disabled"], Wi = {
  __name: "NumberInput",
  props: /* @__PURE__ */ Vt({
    placeholder: {
      type: String,
      default: "Enter amount"
    },
    max: {
      type: Number,
      default: 1e6
    },
    min: {
      type: Number,
      default: 100
    },
    step: {
      type: Number,
      default: 100
    }
  }, {
    modelValue: {
      default: 100
    },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const t = e;
    Le(() => {
      var u;
      typeof window < "u" && ((u = window == null ? void 0 : window.appContext) != null && u.app) && window.appContext.app.directive("longpress", Ut);
    });
    const n = Dn(e, "modelValue"), s = le(() => n.value >= t.max), o = le(() => n.value <= t.min);
    function c(u) {
      const p = n.value + u;
      if (p < t.min) {
        n.value = t.min;
        return;
      }
      if (p > t.max) {
        n.value = t.max;
        return;
      }
      n.value = p;
    }
    return (u, p) => (h(), _("div", Fi, [
      G((h(), _("button", {
        type: "button",
        disabled: o.value,
        class: "spin-btn"
      }, [...p[1] || (p[1] = [
        i("i", { class: "lutefont icon-minus" }, null, -1)
      ])], 8, Hi)), [
        [d(Ut), { handler: c, arg: -100 }]
      ]),
      G(i("input", {
        "onUpdate:modelValue": p[0] || (p[0] = (f) => n.value = f),
        readonly: "",
        type: "number",
        placeholder: e.placeholder,
        min: e.min,
        max: e.max,
        step: e.step
      }, null, 8, Vi), [
        [go, n.value]
      ]),
      G((h(), _("button", {
        type: "button",
        disabled: s.value,
        class: "spin-btn plus"
      }, [...p[2] || (p[2] = [
        i("i", { class: "lutefont icon-plus" }, null, -1)
      ])], 8, ji)), [
        [d(Ut), { handler: c, arg: 100 }]
      ])
    ]));
  }
}, Ai = /* @__PURE__ */ se(Wi, [["__scopeId", "data-v-0b40afc4"]]), qi = { class: "redeem-list" }, Bi = { class: "header" }, Yi = { class: "ctx" }, Gi = { class: "balance" }, Ki = { class: "list" }, Xi = {
  class: "redeem-form",
  action: "#"
}, Qi = { class: "form-item" }, Ji = /* @__PURE__ */ Object.assign({
  name: "CovertCoins"
}, {
  __name: "CovertCoins",
  setup(e) {
    const t = de(), { userinfo: n } = ne(t), { updateUserinfo: s } = t, o = J(100), c = he(), { pageData: u } = ne(c), p = le(() => {
      const w = (o.value / 100).toFixed(0);
      return `Redeem ${o.value} Points for $${w} off your next purchase (Valid for orders $${w * 10}+)`;
    }), f = l(Math.min(n.value.points, 3e3));
    function l(w) {
      return typeof w != "number" || Number.isNaN(w) ? 0 : Math.floor(w / 100) * 100;
    }
    const { send: r } = Je((w) => so(w), { immediate: !1 });
    function a() {
      o.value = f;
    }
    a();
    const v = J(!1);
    async function m() {
      var w;
      v.value = !0;
      try {
        const g = await r({ productCode: u.value.productCode, usedPoints: o.value, number: 1, source: window.innerWidth < 768 ? 5 : 4 });
        await s(), a(), (g == null ? void 0 : g.redeemStatus) === 0 ? (ue("Redeemed successfully !"), c.back({ type: "rewards" })) : ue({
          message: g.message || "Redemption Failed !",
          icon: "icon-error"
        });
      } catch (g) {
        ue({
          message: ((w = g.response) == null ? void 0 : w.message) || "Redemption Failed !",
          icon: "icon-error"
        });
      } finally {
        v.value = !1;
      }
    }
    return (w, g) => {
      var x;
      const S = we("track");
      return h(), _("div", qi, [
        i("div", Bi, [
          i("i", {
            class: "lutefont icon-arrow-left",
            onClick: g[0] || (g[0] = (R) => d(c).back())
          }),
          g[2] || (g[2] = i("h2", null, "Earn CozyCoins", -1)),
          g[3] || (g[3] = i("i", { class: "lutefont icon-close" }, null, -1))
        ]),
        i("div", Yi, [
          i("div", Gi, [
            g[4] || (g[4] = ee(" My CozyCoins: ", -1)),
            i("strong", null, W((x = d(n)) == null ? void 0 : x.points), 1)
          ]),
          oe(d(Ie), {
            "wrapper-class": "list-wrapper",
            "auto-hide": !1,
            "auto-expand": !1
          }, {
            default: ve(() => [
              i("div", Ki, [
                g[6] || (g[6] = i("div", { class: "redeem-item" }, [
                  i("div", { class: "icon" }, [
                    i("i", { class: "lutefont icon-gift" })
                  ]),
                  i("div", { class: "info" }, [
                    i("div", { class: "title" }, " CONVERT YOUR COZYCOINS "),
                    i("div", { class: "date" }, " 100 CozyCoins=$1 ")
                  ])
                ], -1)),
                g[7] || (g[7] = i("div", { class: "line" }, null, -1)),
                i("form", Xi, [
                  i("div", Qi, [
                    oe(Ai, {
                      modelValue: o.value,
                      "onUpdate:modelValue": g[1] || (g[1] = (R) => o.value = R),
                      max: d(f),
                      class: "form__number-input"
                    }, null, 8, ["modelValue", "max"])
                  ]),
                  i("p", null, W(p.value), 1),
                  G((h(), _("button", {
                    type: "submit",
                    class: "form-button",
                    onClick: m
                  }, [...g[5] || (g[5] = [
                    ee(" Redeem ", -1)
                  ])])), [
                    [S, { type: d(u).productTyp, code: d(u).productCode, item: d(u).productName, usedPoints: o.value }, "exchange:detail"]
                  ])
                ])
              ])
            ]),
            _: 1
          })
        ])
      ]);
    };
  }
}), Zi = /* @__PURE__ */ se(Ji, [["__scopeId", "data-v-a59f97e0"]]), er = { class: "redeem-list" }, tr = { class: "header" }, nr = { class: "ctx" }, or = { class: "balance" }, sr = { class: "list" }, ir = { class: "redeem-item" }, rr = { class: "info" }, ar = { class: "title" }, lr = { class: "date" }, cr = { class: "info redeem-form" }, ur = {
  key: 0,
  class: "icon lutefont icon-loading"
}, dr = /* @__PURE__ */ Object.assign({
  name: "CovertDiscount"
}, {
  __name: "CovertDiscount",
  setup(e) {
    const t = he(), { pageData: n } = ne(t), s = de(), { userinfo: o } = ne(s), { updateUserinfo: c } = s, { send: u } = Je(
      (l) => so(l),
      { immediate: !1 }
    ), p = J(!1);
    async function f() {
      var l;
      p.value = !0;
      try {
        const r = await u({
          productCode: n.value.productCode,
          source: window.innerWidth < 768 ? 5 : 4
        });
        await c(), (r == null ? void 0 : r.redeemStatus) === 0 ? (ue("Redeemed successfully !"), t.back({ type: "rewards" })) : ue({
          message: r.message || "Redemption Failed !",
          icon: "icon-error"
        });
      } catch (r) {
        ue({
          message: ((l = r.response) == null ? void 0 : l.message) || "Redemption Failed !",
          icon: "icon-error"
        });
      } finally {
        p.value = !1;
      }
    }
    return (l, r) => {
      var v;
      const a = we("track");
      return h(), _("div", er, [
        i("div", tr, [
          i("i", {
            class: "lutefont icon-arrow-left",
            onClick: r[0] || (r[0] = (m) => d(t).back())
          }),
          r[2] || (r[2] = i("h2", null, "Earn CozyCoins", -1)),
          i("i", {
            class: "lutefont icon-close",
            onClick: r[1] || (r[1] = (...m) => d(t).toggle && d(t).toggle(...m))
          })
        ]),
        i("div", nr, [
          i("div", or, [
            r[3] || (r[3] = ee(" My CozyCoins: ", -1)),
            i("strong", null, W((v = d(o)) == null ? void 0 : v.points), 1)
          ]),
          oe(d(Ie), { "wrapper-class": "list-wrapper" }, {
            default: ve(() => [
              i("div", sr, [
                i("div", ir, [
                  r[4] || (r[4] = i("div", { class: "icon" }, [
                    i("i", { class: "lutefont icon-gift" })
                  ], -1)),
                  i("div", rr, [
                    i("div", ar, W(d(n).productName), 1),
                    i("div", lr, W(`${d(n).exchangePoint} Points`), 1)
                  ])
                ]),
                r[6] || (r[6] = i("div", { class: "line" }, null, -1)),
                i("div", cr, [
                  ee(W(`Redeem ${d(n).exchangePoint} CozyCoins for ${d(n).productName}`) + " ", 1),
                  G((h(), _("button", {
                    class: "form-button btn loading-btn",
                    onClick: f
                  }, [
                    p.value ? (h(), _("i", ur)) : Q("", !0),
                    r[5] || (r[5] = ee(" Redeem ", -1))
                  ])), [
                    [a, {
                      type: d(n).productTyp,
                      code: d(n).productCode,
                      item: d(n).productName,
                      usedPoints: d(n).exchangePoint
                    }, "exchange:detail"]
                  ])
                ])
              ])
            ]),
            _: 1
          })
        ])
      ]);
    };
  }
}), fr = /* @__PURE__ */ se(dr, [["__scopeId", "data-v-0882d92f"]]), pr = { class: "task-detail redeem-list" }, mr = { class: "header" }, vr = { class: "ctx" }, hr = { class: "redeem-item" }, gr = { class: "info" }, _r = { class: "title" }, br = { class: "date" }, yr = { class: "form-item number" }, wr = ["value"], Cr = ["disabled"], xr = {
  key: 0,
  class: "icon lutefont icon-loading"
}, $r = /* @__PURE__ */ Object.assign({
  name: "Email"
}, {
  __name: "Email",
  setup(e) {
    const t = he(), n = de(), { userinfo: s } = ne(n), { pageData: o } = ne(t), { send: c, loading: u } = Je((f) => di(f), { immediate: !1 });
    async function p() {
      if (o.value.completionStatus !== 1) {
        if (!s.value.email) {
          ue({
            message: "Email not found",
            icon: "icon-error"
          });
          return;
        }
        c({ email: s.value.email }).then(() => {
          ue("Subscription successful"), n.updateUserinfo(), io("update:task:list"), t.back();
        }).catch(() => {
          ue("Subscription failed");
        });
      }
    }
    return (f, l) => {
      const r = we("track");
      return h(), _("div", pr, [
        i("div", mr, [
          i("i", {
            class: "lutefont icon-arrow-left",
            onClick: l[0] || (l[0] = (a) => d(t).back())
          }),
          l[2] || (l[2] = i("h2", null, "Earn CozyCoins", -1)),
          i("i", {
            class: "lutefont icon-close",
            onClick: l[1] || (l[1] = (...a) => d(t).toggle && d(t).toggle(...a))
          })
        ]),
        i("div", vr, [
          oe(d(Ie), {
            "wrapper-class": "list-wrapper",
            "auto-hide": !1,
            "auto-expand": !1
          }, {
            default: ve(() => {
              var a, v;
              return [
                i("div", hr, [
                  l[3] || (l[3] = i("div", { class: "icon" }, [
                    i("i", { class: "lutefont icon-gift" })
                  ], -1)),
                  i("div", gr, [
                    i("div", _r, W(d(o).title), 1),
                    i("div", br, W(d(o).pointsDesc), 1)
                  ])
                ]),
                l[6] || (l[6] = i("div", { class: "line-wrapper" }, [
                  i("div", { class: "line" })
                ], -1)),
                i("form", {
                  class: "redeem-form",
                  action: "#",
                  onSubmit: rt(p, ["prevent"])
                }, [
                  l[5] || (l[5] = i("h4", null, "Complete email subscription", -1)),
                  i("div", yr, [
                    i("input", {
                      readonly: "",
                      value: (a = d(s)) == null ? void 0 : a.email,
                      class: "form-item__input",
                      type: "email",
                      placeholder: "Enter your Email"
                    }, null, 8, wr)
                  ]),
                  G((h(), _("button", {
                    type: "submit",
                    class: ye(["form-button btn loading-btn", { loading: d(u), completed: d(o).completionStatus === 1 }]),
                    disabled: d(o).completionStatus === 1
                  }, [
                    d(u) ? (h(), _("i", xr)) : Q("", !0),
                    l[4] || (l[4] = ee(" Subscription ", -1))
                  ], 10, Cr)), [
                    [r, { type: d(o).type, item: d(o).title, email: (v = d(s)) == null ? void 0 : v.email }, "task:detail"]
                  ])
                ], 32)
              ];
            }),
            _: 1
          })
        ])
      ]);
    };
  }
}), Er = { class: "redeem-list" }, Sr = { class: "header" }, kr = { class: "ctx" }, Tr = { class: "list" }, Pr = ["onClick"], Rr = { class: "faq-title" }, Lr = { class: "faq-content-wrapper" }, Ir = ["innerHTML"], Mr = /* @__PURE__ */ Object.assign({
  name: "Faq"
}, {
  __name: "Faq",
  setup(e) {
    const t = he(), n = J([
      {
        active: !1,
        title: "What is the Momcozy Membership Program?",
        content: "The Momcozy Membership Program is a tiered rewards system. The more you engage, the more exclusive benefits you unlock."
      },
      {
        active: !1,
        title: "How do I join the membership program?",
        content: "If you already have an account on momcozy.com and have completed email activation, you are already participating in the program. Simply log in to your account!<br/>If you don't have an account, you just need to register for an momcozy account and complete the email activation steps so you can start earning rewards."
      },
      {
        active: !1,
        title: "What are the membership tiers?",
        content: `<p>There are four tiers:</p><p>Newbie (Create an account)</p><p>Explorer (First Order)</p><p>Enthusiant (spend $300 more)</p><p>Elite (spend $500 more)</p><p><a target="_blank" href="${Ve}/memberShip">Learn More</a></p>`
      },
      {
        active: !1,
        title: "How do I upgrade my membership tier?",
        content: "Your tier is automatically calculated based on your total spending within the calendar year. Upgrades happen within 24 hours after meeting the threshold."
      },
      {
        active: !1,
        title: "How long does my tier last?",
        content: "Your tier is valid for the current calendar year (Jan 1 – Dec 31). It will be re-evaluated annually based on your total spend."
      },
      {
        active: !1,
        title: "What happened to my Momcozy Points?",
        content: "Your Momcozy Points have been upgraded to CozyCoins.You can now use CozyCoins to redeem eligible products or discounts."
      },
      {
        active: !1,
        title: "What are CozyCoins?",
        content: "CozyCoins are the exclusive reward points within the Momcozy Membership Program. You can earn CozyCoins through shopping, daily check-ins, community interactions, and more. Use them to redeem discount coupons, exclusive gifts, or join members-only events."
      },
      {
        active: !1,
        title: "Where can I see my CozyCoins?",
        content: "My Account > CozyCoins to view your current balance and history"
      },
      {
        active: !1,
        title: "What can I redeem my CozyCoins for?",
        content: "CozyCoins can be redeemed for:discount coupons , gift cards, etc."
      },
      {
        active: !1,
        title: "Is there a limit to how many points I can redeem at once when I convert my CozyCoins ?",
        content: "Yes. You can redeem up to $30 worth of coupons per transaction."
      },
      {
        active: !1,
        title: "Do CozyCoins expire?",
        content: "Yes, points are valid for 180 days from the date they’re earned and will expire if unused."
      }
    ]);
    return (s, o) => (h(), _("div", Er, [
      i("div", Sr, [
        i("i", {
          class: "lutefont icon-arrow-left",
          onClick: o[0] || (o[0] = (c) => d(t).back())
        }),
        o[2] || (o[2] = i("h2", null, "FAQ", -1)),
        i("i", {
          class: "lutefont icon-close",
          onClick: o[1] || (o[1] = (...c) => d(t).toggle && d(t).toggle(...c))
        })
      ]),
      i("div", kr, [
        oe(d(Ie), {
          "wrapper-class": "list-wrapper",
          "auto-hide": !1,
          "auto-expand": !1
        }, {
          default: ve(() => [
            i("ul", Tr, [
              (h(!0), _(ce, null, qe(n.value, (c, u) => (h(), _(ce, { key: u }, [
                i("li", {
                  class: ye({ active: c.active }),
                  onClick: (p) => c.active = !c.active
                }, [
                  i("div", Rr, [
                    i("p", null, W(c.title), 1),
                    (h(), _("svg", {
                      class: ye(["icon", { active: c.active }]),
                      viewBox: "0 0 200 200",
                      xmlns: "http://www.w3.org/2000/svg"
                    }, [...o[3] || (o[3] = [
                      i("line", {
                        class: "icon-line h-line",
                        x1: "50",
                        y1: "100",
                        x2: "150",
                        y2: "100"
                      }, null, -1),
                      i("line", {
                        class: "icon-line v-line",
                        x1: "100",
                        y1: "50",
                        x2: "100",
                        y2: "150"
                      }, null, -1)
                    ])], 2))
                  ]),
                  i("div", Lr, [
                    i("div", {
                      class: "faq-content",
                      innerHTML: c.content
                    }, null, 8, Ir)
                  ])
                ], 10, Pr),
                o[4] || (o[4] = i("li", { class: "line full-line" }, null, -1))
              ], 64))), 128))
            ])
          ]),
          _: 1
        })
      ])
    ]));
  }
}), Dr = /* @__PURE__ */ se(Mr, [["__scopeId", "data-v-e8609505"]]), pe = typeof window < "u" ? window : void 0, Tn = 3;
async function zr(e, t, n) {
  await new Promise((f) => requestAnimationFrame(f));
  const s = d(n).getBoundingClientRect(), o = (pe == null ? void 0 : pe.innerWidth) ?? 0, u = ((pe == null ? void 0 : pe.innerHeight) ?? 0) - s.height - ((t == null ? void 0 : t.bottom) ?? 0), p = o - s.width - ((t == null ? void 0 : t.right) ?? 0);
  return (e == null ? void 0 : e.x) < t.left && (e.x = t.left), (e == null ? void 0 : e.y) < t.top && (e.y = t.top), (e == null ? void 0 : e.x) > p && (e.x = p), (e == null ? void 0 : e.y) > u && (e.y = u), {
    x: Number(e == null ? void 0 : e.x),
    y: Number(e == null ? void 0 : e.y)
  };
}
function Nr(e) {
  return typeof e == "number" ? {
    top: e,
    left: e,
    right: e,
    bottom: e
  } : {
    top: Number((e == null ? void 0 : e.top) ?? 0),
    right: Number((e == null ? void 0 : e.right) ?? 0),
    bottom: Number((e == null ? void 0 : e.bottom) ?? 0),
    left: Number((e == null ? void 0 : e.left) ?? 0)
  };
}
function Ft(e, t, n) {
  t && e.preventDefault(), n && e.stopPropagation();
}
function Or(e) {
  var t, n;
  return (n = (t = e == null ? void 0 : e.offsetParent) == null ? void 0 : t.getBoundingClientRect) == null ? void 0 : n.call(t);
}
function Ur(e, t = {}) {
  const {
    axis: n = "y",
    disabled: s = !1,
    draggingElement: o = pe,
    initialValue: c = { x: 0, y: 0 },
    safeArea: u = 0,
    preventDefault: p = !1,
    stopPropagation: f = !1,
    onStart: l,
    onMove: r,
    onEnd: a
  } = t, v = Nr(u), m = J({ x: 0, y: 0 }), w = J(!1);
  let g = null, S = null, x = null, R = null, k = null, C = !1, I = !1;
  const E = Mn((N) => {
    const F = d(e);
    if (!F)
      return;
    const H = (ie) => M(ie, F), $e = (ie) => {
      var K;
      I && (I = !1, ie.preventDefault(), ie.stopPropagation(), (K = ie.stopImmediatePropagation) == null || K.call(ie));
    };
    F.addEventListener("pointerdown", H), F.addEventListener("click", $e, !0), N(() => {
      F.removeEventListener("pointerdown", H), F.removeEventListener("click", $e, !0);
    });
  });
  async function $() {
    typeof c == "function" && (m.value = {
      ...m.value,
      ...await c()
    }), m.value = await zr(m.value, v, e);
  }
  function M(N, F) {
    if (N.button !== void 0 && N.button !== 0 || d(s) || (R = o ?? pe, !R))
      return;
    const H = F.getBoundingClientRect();
    if (g = {
      x: N.clientX - H.left,
      y: N.clientY - H.top
    }, S = N.pointerId, x = F, k = { x: N.clientX, y: N.clientY }, C = !1, I = !1, Ft(N, p, f), (l == null ? void 0 : l({ ...m.value }, N)) === !1) {
      g = null, S = null, x = null, R = null, k = null, C = !1, I = !1;
      return;
    }
    w.value = !0, R.addEventListener("pointermove", P), R.addEventListener("pointerup", D), R.addEventListener("pointercancel", D);
  }
  function P(N) {
    if (!w.value || N.pointerId !== S || !x || !g)
      return;
    if (!C && k) {
      const Y = Math.abs(N.clientX - k.x), Ce = Math.abs(N.clientY - k.y);
      (Y > Tn || Ce > Tn) && (C = !0);
    }
    const F = Or(x), H = x.getBoundingClientRect(), $e = (F == null ? void 0 : F.width) ?? (pe == null ? void 0 : pe.innerWidth) ?? H.width, ie = (F == null ? void 0 : F.height) ?? (pe == null ? void 0 : pe.innerHeight) ?? H.height, K = (F == null ? void 0 : F.left) ?? 0, A = (F == null ? void 0 : F.top) ?? 0;
    let re = N.clientX - g.x - K, L = N.clientY - g.y - A;
    if (n !== "y") {
      const Y = v.left, Ce = Math.max(Y, $e - H.width - v.right);
      re = Math.min(Math.max(Y, re), Ce);
    }
    if (n !== "x") {
      const Y = v.top, Ce = Math.max(Y, ie - H.height - v.bottom);
      L = Math.min(Math.max(Y, L), Ce);
    }
    const q = {
      x: n === "y" ? m.value.x : re,
      y: n === "x" ? m.value.y : L
    };
    m.value = q, Ft(N, p, f), r == null || r({ ...q }, N);
  }
  function D(N) {
    !w.value || N.pointerId !== S || (Ft(N, p, f), a == null || a({ ...m.value }, N), I = C, z());
  }
  function z() {
    R && (R.removeEventListener("pointermove", P), R.removeEventListener("pointerup", D), R.removeEventListener("pointercancel", D), R = null, x = null, g = null, S = null, w.value = !1, k = null, C = !1);
  }
  return _o(() => {
    z(), E == null || E();
  }), Le(() => {
    $();
  }), {
    x: le(() => m.value.x),
    y: le(() => m.value.y),
    position: m,
    isDragging: w
  };
}
function ro(e = () => null) {
  const t = J(null);
  function n(s) {
    const { scrollTop: o, scrollHeight: c, clientHeight: u } = s.target;
    o + u + 20 >= c && e();
  }
  return Le(() => {
    t.value.scrollEl.addEventListener("scroll", n);
  }), Ye(() => {
    var o;
    const s = (o = t.value) == null ? void 0 : o.scrollEl;
    s && s.removeEventListener("scroll", n);
  }), {
    scrollRef: t,
    handleScroll: n
  };
}
function Fr() {
  const e = J(""), t = he(), n = de();
  window.addEventListener("visibilitychange", () => {
    document.visibilityState === "visible" && (e.value = Kt());
  }), Ee(e, () => {
    n.updateUserinfo();
  }), document.addEventListener("LUTE:AUTH:EXPIRED", () => {
    Po(), n.clearUserinfo(), t.clearComp(), ue({
      message: "Login expired !",
      icon: "icon-error",
      duration: 3e3
    });
  });
}
const Hr = { class: "redeem-list" }, Vr = { class: "header" }, jr = { class: "ctx" }, Wr = { class: "balance" }, Ar = { class: "list" }, qr = { class: "redeem-item" }, Br = { class: "info" }, Yr = { class: "title" }, Gr = { class: "date" }, Kr = { class: "count" }, Xr = {
  key: 1,
  class: "loading"
}, Qr = /* @__PURE__ */ Object.assign({
  name: "History"
}, {
  __name: "History",
  setup(e) {
    const t = he(), n = de(), { userinfo: s } = ne(n), { loading: o, data: c, page: u, total: p, isLastPage: f, reload: l } = Jn((v, m) => oi({ pageNum: v, pageSize: m }), {
      initialData: { userPointDetailList: [] },
      initialPage: 1,
      // 初始页码，默认为1
      initialPageSize: 10,
      data: (v) => v.userPointDetailList || [],
      append: !0
    });
    function r() {
      f.value || u.value++;
    }
    const { scrollRef: a } = ro(r);
    return bo(l), (v, m) => {
      var w;
      return h(), _("div", Hr, [
        i("div", Vr, [
          i("i", {
            class: "lutefont icon-arrow-left",
            onClick: m[0] || (m[0] = (...g) => d(t).back && d(t).back(...g))
          }),
          m[2] || (m[2] = i("h2", null, "History", -1)),
          i("i", {
            class: "lutefont icon-close",
            onClick: m[1] || (m[1] = (...g) => d(t).toggle && d(t).toggle(...g))
          })
        ]),
        i("div", jr, [
          i("div", Wr, [
            m[3] || (m[3] = ee(" My CozyCoins: ", -1)),
            i("strong", null, W((w = d(s)) == null ? void 0 : w.points), 1)
          ]),
          oe(d(Ie), {
            ref_key: "scrollRef",
            ref: a,
            "wrapper-class": "list-wrapper"
          }, {
            default: ve(() => [
              d(o) && !d(p) ? (h(), me(xt, { key: 0 })) : Q("", !0),
              i("ul", Ar, [
                (h(!0), _(ce, null, qe(d(c), (g) => (h(), _(ce, {
                  key: g.detailCode
                }, [
                  i("li", qr, [
                    i("div", Br, [
                      i("div", Yr, W(g.remark), 1),
                      i("div", Gr, W(g.expiredTime ? d(So)(g.expiredTime).format("YYYY-MM-DD HH:mm:ss") : ""), 1)
                    ]),
                    i("div", Kr, W(g.point > 0 ? `+${g.point}` : g.point), 1)
                  ]),
                  m[4] || (m[4] = i("li", { class: "line" }, null, -1))
                ], 64))), 128))
              ]),
              d(o) && d(p) > 0 ? (h(), _("div", Xr, [...m[5] || (m[5] = [
                i("i", { class: "icon big lutefont icon-loading" }, null, -1)
              ])])) : Q("", !0)
            ]),
            _: 1
          }, 512)
        ])
      ]);
    };
  }
}), Jr = /* @__PURE__ */ se(Qr, [["__scopeId", "data-v-c957c9be"]]), Zr = { class: "guest" }, ea = ["href"], ta = {
  __name: "GuestLogin",
  setup(e) {
    return (t, n) => {
      const s = we("track");
      return h(), _("div", Zr, [
        n[1] || (n[1] = i("p", { class: "tips" }, [
          ee(" Your CozyCoins perks are waiting"),
          i("br"),
          ee(" Log in to get started. ")
        ], -1)),
        G((h(), _("a", { href: d(en) }, [...n[0] || (n[0] = [
          i("button", null, "Log In", -1)
        ])], 8, ea)), [
          [s, { from: "index" }, "login"]
        ])
      ]);
    };
  }
}, na = /* @__PURE__ */ se(ta, [["__scopeId", "data-v-40cb7dfb"]]), oa = {}, sa = { class: "tag" };
function ia(e, t) {
  return h(), _("div", sa, [
    In(e.$slots, "default", {}, void 0, !0)
  ]);
}
const ao = /* @__PURE__ */ se(oa, [["render", ia], ["__scopeId", "data-v-c47af534"]]), ra = { class: "prizes" }, aa = { class: "icons" }, la = {
  __name: "Prizes",
  setup(e) {
    const t = he();
    function n() {
      window.open(Ve, "_blank");
    }
    return (s, o) => {
      const c = we("track");
      return h(), _("ul", ra, [
        G((h(), _("li", {
          onClick: o[0] || (o[0] = (u) => d(t).setComp("coins"))
        }, [...o[2] || (o[2] = [
          i("i", { class: "lutefont icon-points" }, null, -1),
          i("span", { class: "ctx" }, "Earn CozyCoins", -1),
          i("i", { class: "lutefont icon-arrow" }, null, -1)
        ])])), [
          [c, { item: "coins" }, "menu"]
        ]),
        G((h(), _("li", {
          onClick: o[1] || (o[1] = (u) => d(t).setComp("rewards"))
        }, [
          o[5] || (o[5] = i("i", { class: "lutefont icon-gift" }, null, -1)),
          o[6] || (o[6] = i("span", { class: "ctx" }, "Redeem Rewards", -1)),
          i("div", aa, [
            oe(ao, null, {
              default: ve(() => [...o[3] || (o[3] = [
                ee("New", -1)
              ])]),
              _: 1
            }),
            o[4] || (o[4] = i("i", { class: "lutefont icon-arrow" }, null, -1))
          ])
        ])), [
          [c, { item: "rewards" }, "menu"]
        ]),
        G((h(), _("li", { onClick: n }, [...o[7] || (o[7] = [
          i("i", { class: "lutefont icon-gift" }, null, -1),
          i("span", { class: "ctx" }, "View More Benefits", -1),
          i("i", { class: "lutefont icon-arrow" }, null, -1)
        ])])), [
          [c, { item: "more" }, "menu"]
        ])
      ]);
    };
  }
}, ca = /* @__PURE__ */ se(la, [["__scopeId", "data-v-7b336b17"]]), ua = { class: "userinfo" }, da = { class: "avatar" }, fa = ["src"], pa = {
  key: 1,
  class: "img",
  src: "https://cdn.shopify.com/s/files/1/0559/2321/2486/files/avatar_fbb6ef1f-f3f3-40bb-9d27-207a2c9c7c6f.svg?v=1756462416",
  alt: ""
}, ma = { class: "level" }, va = { class: "name" }, ha = { class: "email" }, ga = {
  __name: "UserInfo",
  setup(e) {
    const t = he(), n = de(), { userinfo: s } = ne(n);
    return (o, c) => {
      var u, p, f, l;
      return h(), _("div", ua, [
        i("div", da, [
          d(s).avatar ? (h(), _("img", {
            key: 0,
            class: "img",
            src: d(s).avatar,
            alt: ""
          }, null, 8, fa)) : (h(), _("img", pa)),
          i("div", ma, W(`Lv.${d(s).memberLevel}`), 1)
        ]),
        i("div", va, W((u = d(s)) != null && u.firstName || (p = d(s)) != null && p.lastName ? `${d(s).firstName} ${d(s).lastName}` : "Mom"), 1),
        i("div", ha, W((f = d(s)) == null ? void 0 : f.email), 1),
        i("div", {
          class: "coins",
          onClick: c[0] || (c[0] = (r) => d(t).setComp("history"))
        }, [
          i("span", null, [
            c[1] || (c[1] = ee("CozyCoins: ", -1)),
            i("strong", null, W((l = d(s)) == null ? void 0 : l.points), 1)
          ]),
          c[2] || (c[2] = i("i", { class: "lutefont icon-history" }, null, -1))
        ])
      ]);
    };
  }
}, _a = /* @__PURE__ */ se(ga, [["__scopeId", "data-v-06a9be38"]]), ba = { class: "box" }, ya = { class: "info" }, wa = /* @__PURE__ */ Object.assign({
  name: "Index"
}, {
  __name: "index",
  setup(e) {
    const t = he(), n = de();
    return (s, o) => (h(), _("div", ba, [
      i("i", {
        class: "opreate lutefont icon-question",
        onClick: o[0] || (o[0] = (c) => d(t).setComp("faq"))
      }),
      i("i", {
        class: "opreate lutefont icon-close",
        onClick: o[1] || (o[1] = (...c) => d(t).toggle && d(t).toggle(...c))
      }),
      o[3] || (o[3] = i("div", { class: "title" }, [
        i("h2", null, "Welcome to"),
        i("p", null, "Member Center")
      ], -1)),
      i("div", ya, [
        d(n).userinfo ? (h(), me(_a, {
          key: 1,
          class: "user"
        })) : (h(), me(na, { key: 0 })),
        o[2] || (o[2] = i("div", { class: "line" }, null, -1)),
        oe(ca)
      ])
    ]));
  }
}), Ca = /* @__PURE__ */ se(wa, [["__scopeId", "data-v-0dbcc85b"]]), xa = { class: "progress-container" }, $a = {
  __name: "Progress",
  props: {
    value: {
      type: Number,
      default: 0,
      validator: (e) => e >= 0 && e <= 100
    }
  },
  setup(e) {
    const t = e, n = J(0);
    return Ee(() => t.value, (s) => {
      n.value = s;
    }, { immediate: !0 }), (s, o) => (h(), _("div", xa, [
      i("div", {
        class: "progress-bar",
        style: ze({ width: `${n.value}%` })
      }, null, 4)
    ]));
  }
}, Ea = /* @__PURE__ */ se($a, [["__scopeId", "data-v-bd9b04ef"]]), Sa = {
  key: 1,
  class: "list"
}, ka = { class: "redeem-item" }, Ta = { class: "info" }, Pa = { class: "title" }, Ra = { class: "product-name" }, La = { class: "date" }, Ia = {
  key: 0,
  class: "progress-wrapper"
}, Ma = { class: "operate" }, Da = ["onClick"], za = {
  key: 0,
  class: "icon lutefont icon-loading"
}, Na = {
  __name: "Redeem",
  setup(e) {
    const t = he(), n = de(), { userinfo: s } = ne(n), o = le(() => s.value ? ai : li), { loading: c, data: u } = Je(
      () => o.value({
        page: 1,
        pageSize: 100,
        productType: [3, 4, 5, 6, 7]
      }),
      {
        initialData: [],
        async middleware(f, l) {
          return (await l()).map((a) => {
            let v = "";
            return a.productCode === "PP000004" ? v = " (Valid for orders $150+)" : a.productCode === "PP000003" && (v = " (Valid for orders $80+)"), {
              ...a,
              productName: `${a.productName} ${v}`
            };
          });
        }
      }
    );
    async function p(f) {
      if (f.productType === 5) {
        t.setComp("covertCoins", f);
        return;
      }
      t.setComp("covertDiscount", f);
    }
    return (f, l) => {
      const r = we("track");
      return h(), me(d(Ie), { "wrapper-class": "list-wrapper" }, {
        default: ve(() => [
          d(c) ? (h(), me(xt, { key: 0 })) : (h(), _("ul", Sa, [
            (h(!0), _(ce, null, qe(d(u), (a) => {
              var v, m, w, g;
              return h(), _(ce, {
                key: a.productCode
              }, [
                G((h(), _("li", ka, [
                  l[2] || (l[2] = i("div", { class: "icon" }, [
                    i("i", { class: "lutefont icon-gift" })
                  ], -1)),
                  i("div", Ta, [
                    i("div", Pa, [
                      i("div", Ra, W(a.productType === 5 ? "Convert your CozyCoins" : a.productName), 1),
                      a.productCode === "PP019001" ? (h(), me(ao, { key: 0 }, {
                        default: ve(() => [...l[0] || (l[0] = [
                          ee(" only for 7.7-7.9 ", -1)
                        ])]),
                        _: 1
                      })) : Q("", !0)
                    ]),
                    i("div", La, W(a.productType === 5 ? "100 CozyCoins=$1" : `${a.exchangePoint} CozyCoins`), 1),
                    a.exchangePoint > ((v = d(s)) == null ? void 0 : v.points) ? (h(), _("div", Ia, [
                      oe(Ea, {
                        value: Math.floor(((m = d(s)) == null ? void 0 : m.points) / a.exchangePoint * 100)
                      }, null, 8, ["value"])
                    ])) : Q("", !0)
                  ]),
                  i("div", Ma, [
                    a.exchangePoint <= ((w = d(s)) == null ? void 0 : w.points) ? (h(), _("button", {
                      key: 0,
                      class: "btn loading-btn loading",
                      onClick: (S) => p(a)
                    }, [
                      a.loading ? (h(), _("i", za)) : Q("", !0),
                      l[1] || (l[1] = ee(" Redeem ", -1))
                    ], 8, Da)) : Q("", !0)
                  ])
                ])), [
                  [r, {
                    type: a.productTyp,
                    code: a.productCode,
                    item: a.productName,
                    canExchange: a.exchangePoint <= ((g = d(s)) == null ? void 0 : g.points)
                  }, "exchange"]
                ]),
                l[3] || (l[3] = i("li", { class: "line" }, null, -1))
              ], 64);
            }), 128))
          ]))
        ]),
        _: 1
      });
    };
  }
}, Oa = {
  key: 1,
  class: "list"
}, Ua = { class: "redeem-item" }, Fa = { class: "info" }, Ha = { class: "title" }, Va = ["onClick"], ja = { class: "operate" }, Wa = ["onClick"], Aa = {
  key: 2,
  class: "list"
}, qa = {
  key: 3,
  class: "loading"
}, Ba = {
  key: 1,
  class: "list"
}, Ya = {
  __name: "Rewards",
  setup(e) {
    const t = de(), { userinfo: n } = ne(t), { loading: s, data: o, page: c, total: u, isLastPage: p } = Jn(
      (m, w) => ci({ pageNum: m, pageSize: w }),
      {
        initialData: { exchangeProductList: [] },
        initialPage: 1,
        // 初始页码，默认为1
        initialPageSize: 10,
        data: (m) => m.exchangeProductList || [],
        append: !0,
        immediate: !!n.value
      }
    );
    function f() {
      p.value || c.value++;
    }
    const { scrollRef: l } = ro(f);
    function r(m) {
      return !m || m === "no discount code available" ? "" : m;
    }
    async function a(m) {
      if (m.productType === 7) {
        const w = await ui(m.ticketCode);
        window.open(w);
      } else
        window.open(`/discount/${m.ticketCode}`);
    }
    function v(m) {
      m && navigator.clipboard.writeText(m).then(() => {
        ue("Copied to clipboard");
      }).catch((w) => {
        console.error("Failed to copy: ", w);
      });
    }
    return (m, w) => {
      const g = we("track"), S = we("visible-track");
      return G((h(), me(d(Ie), {
        ref_key: "scrollRef",
        ref: l,
        "wrapper-class": "list-wrapper"
      }, {
        default: ve(() => [
          d(n) ? (h(), _(ce, { key: 0 }, [
            d(s) && !d(u) ? (h(), me(xt, { key: 0 })) : Q("", !0),
            d(o).length ? (h(), _("ul", Oa, [
              (h(!0), _(ce, null, qe(d(o), (x) => (h(), _(ce, {
                key: x.id
              }, [
                i("li", Ua, [
                  w[1] || (w[1] = i("div", { class: "icon" }, [
                    i("i", { class: "lutefont icon-gift" })
                  ], -1)),
                  i("div", Fa, [
                    i("div", Ha, W(x.productName), 1),
                    G((h(), _("div", {
                      class: "date",
                      onClick: (R) => v(r(x.ticketCode))
                    }, [
                      ee(W(r(x.ticketCode) || "-"), 1)
                    ], 8, Va)), [
                      [g, {
                        type: x.productType,
                        code: x.ticketCode,
                        item: x.productName
                      }, "point:copy"]
                    ])
                  ]),
                  i("div", ja, [
                    r(x.ticketCode) ? G((h(), _("button", {
                      key: 0,
                      class: "btn",
                      onClick: (R) => a(x)
                    }, [...w[0] || (w[0] = [
                      ee(" Use Coupon ", -1)
                    ])], 8, Wa)), [
                      [g, {
                        type: x.productType,
                        code: x.ticketCode,
                        item: x.productName
                      }, "point:jump"]
                    ]) : Q("", !0)
                  ])
                ]),
                w[2] || (w[2] = i("li", { class: "line" }, null, -1))
              ], 64))), 128))
            ])) : Q("", !0),
            !d(s) && !d(o).length ? (h(), _("div", Aa, [...w[3] || (w[3] = [
              i("p", null, "No rewards redeemed yet.", -1)
            ])])) : Q("", !0),
            d(s) && d(u) > 0 ? (h(), _("div", qa, [...w[4] || (w[4] = [
              i("i", { class: "icon big lutefont icon-loading" }, null, -1)
            ])])) : Q("", !0)
          ], 64)) : (h(), _("div", Ba, [...w[5] || (w[5] = [
            i("p", null, "Log in now to check your rewards.", -1)
          ])]))
        ]),
        _: 1
      })), [
        [S, void 0, "visible:rewards"]
      ]);
    };
  }
}, Ga = /* @__PURE__ */ se(Ya, [["__scopeId", "data-v-16cba854"]]), Ka = { class: "tabs-container" }, Xa = { class: "tabs-header" }, Qa = ["onClick"], Ja = {
  __name: "Tabs",
  props: /* @__PURE__ */ Vt({
    tabs: {
      type: Array,
      required: !0
    }
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ Vt(["tabChange"], ["update:modelValue"]),
  setup(e, { emit: t }) {
    const n = e, s = t, o = Dn(e, "modelValue");
    Ee(
      () => o.value,
      (l) => {
        const r = n.tabs.findIndex((a) => a.name === l);
        r !== -1 && f(r);
      }
    );
    function c(l, r) {
      o.value !== l.name && (o.value = l.name, s("tabChange", l.name), f(r));
    }
    const u = J([]), p = J({
      width: "0px",
      left: "0px"
    });
    function f(l) {
      if (u.value && u.value.length > 0) {
        const r = u.value[l];
        r && (p.value = {
          width: `${r.offsetWidth}px`,
          left: `${r.offsetLeft}px`
        });
      }
    }
    return Le(() => {
      f(0);
    }), (l, r) => (h(), _("div", Ka, [
      i("div", Xa, [
        (h(!0), _(ce, null, qe(e.tabs, (a, v) => (h(), _("div", {
          key: a.name,
          ref_for: !0,
          ref_key: "tabRefs",
          ref: u,
          class: ye(["tab", { active: o.value === a.name }]),
          onClick: (m) => c(a, v)
        }, W(a.label), 11, Qa))), 128)),
        i("div", {
          class: "slider",
          style: ze(p.value)
        }, null, 4)
      ])
    ]));
  }
}, Za = /* @__PURE__ */ se(Ja, [["__scopeId", "data-v-ddd38ec2"]]), el = { class: "redeem-list" }, tl = { class: "header" }, nl = { class: "ctx" }, ol = ["href"], sl = {
  key: 1,
  class: "balance"
}, il = /* @__PURE__ */ Object.assign({
  name: "Rewards"
}, {
  __name: "index",
  setup(e) {
    const t = de(), { userinfo: n } = ne(t), s = he(), { pageData: o } = ne(s), c = J("redeem");
    Ee(
      () => o.value.type,
      (p) => {
        c.value = p || "redeem";
      }
    );
    const u = [
      {
        label: "Redeem",
        name: "redeem"
      },
      {
        label: "Your Rewards",
        name: "rewards"
      }
    ];
    return (p, f) => {
      var r;
      const l = we("track");
      return h(), _("div", el, [
        i("div", tl, [
          i("i", {
            class: "lutefont icon-arrow-left",
            onClick: f[0] || (f[0] = (a) => d(s).back())
          }),
          f[3] || (f[3] = i("h2", null, "Redeem Rewards", -1)),
          i("i", {
            class: "lutefont icon-close",
            onClick: f[1] || (f[1] = (...a) => d(s).toggle && d(s).toggle(...a))
          })
        ]),
        i("div", nl, [
          d(n) ? (h(), _("div", sl, [
            f[5] || (f[5] = ee(" My CozyCoins: ", -1)),
            i("strong", null, W((r = d(n)) == null ? void 0 : r.points), 1)
          ])) : G((h(), _("a", {
            key: 0,
            href: d(en),
            class: "balance link"
          }, [...f[4] || (f[4] = [
            i("strong", null, "Log In >", -1)
          ])], 8, ol)), [
            [l, { from: "rewards" }, "login"]
          ]),
          oe(Za, {
            modelValue: c.value,
            "onUpdate:modelValue": f[2] || (f[2] = (a) => c.value = a),
            class: "tabs",
            tabs: u
          }, null, 8, ["modelValue"]),
          c.value === "redeem" ? (h(), me(Na, { key: 2 })) : Q("", !0),
          c.value === "rewards" ? (h(), me(Ga, { key: 3 })) : Q("", !0)
        ])
      ]);
    };
  }
}), rl = /* @__PURE__ */ se(il, [["__scopeId", "data-v-260701dd"]]), al = { class: "task-detail redeem-list" }, ll = { class: "header" }, cl = { class: "ctx" }, ul = { class: "redeem-item" }, dl = { class: "info" }, fl = { class: "title" }, pl = { class: "date" }, ml = { class: "form-item number" }, vl = ["value"], hl = ["disabled"], gl = {
  key: 0,
  class: "icon lutefont icon-loading"
}, _l = /* @__PURE__ */ Object.assign({
  name: "Sms"
}, {
  __name: "Sms",
  setup(e) {
    const t = he(), n = de(), { userinfo: s } = ne(n), { pageData: o } = ne(t), { send: c, loading: u } = Je((f) => fi(f), { immediate: !1 });
    async function p() {
      if (o.value.completionStatus !== 1) {
        if (!s.value.phone) {
          ue({
            message: "Phone not found",
            icon: "icon-error"
          });
          return;
        }
        c({ phone: s.value.phone }).then(() => {
          ue("Subscription successful"), n.updateUserinfo(), io("update:task:list"), t.back();
        }).catch(() => {
          ue("Subscription failed");
        });
      }
    }
    return (f, l) => {
      const r = we("track");
      return h(), _("div", al, [
        i("div", ll, [
          i("i", {
            class: "lutefont icon-arrow-left",
            onClick: l[0] || (l[0] = (a) => d(t).back())
          }),
          l[2] || (l[2] = i("h2", null, "Earn CozyCoins", -1)),
          i("i", {
            class: "lutefont icon-close",
            onClick: l[1] || (l[1] = (...a) => d(t).toggle && d(t).toggle(...a))
          })
        ]),
        i("div", cl, [
          oe(d(Ie), { "wrapper-class": "list-wrapper" }, {
            default: ve(() => {
              var a, v;
              return [
                i("div", ul, [
                  l[3] || (l[3] = i("div", { class: "icon" }, [
                    i("i", { class: "lutefont icon-gift" })
                  ], -1)),
                  i("div", dl, [
                    i("div", fl, W(d(o).title), 1),
                    i("div", pl, W(d(o).pointsDesc), 1)
                  ])
                ]),
                l[6] || (l[6] = i("div", { class: "line-wrapper" }, [
                  i("div", { class: "line" })
                ], -1)),
                i("form", {
                  class: "redeem-form",
                  action: "#",
                  onSubmit: rt(p, ["prevent"])
                }, [
                  l[5] || (l[5] = i("h4", null, "Enter your mobile number to subscribe !", -1)),
                  i("div", ml, [
                    i("input", {
                      readonly: "",
                      value: (a = d(s)) == null ? void 0 : a.phone,
                      class: "form-item__input",
                      type: "text",
                      placeholder: "Enter your mobile number"
                    }, null, 8, vl)
                  ]),
                  G((h(), _("button", {
                    type: "submit",
                    disabled: d(o).completionStatus === 1,
                    class: ye(["form-button btn loading-btn", { loading: d(u), completed: d(o).completionStatus === 1 }])
                  }, [
                    d(u) ? (h(), _("i", gl)) : Q("", !0),
                    l[4] || (l[4] = ee(" Subscription ", -1))
                  ], 10, hl)), [
                    [r, { type: d(o).type, item: d(o).title, phone: (v = d(s)) == null ? void 0 : v.phone }, "task:detail"]
                  ])
                ], 32)
              ];
            }),
            _: 1
          })
        ])
      ]);
    };
  }
}), Pn = {
  index: Ca,
  history: Jr,
  coins: Ui,
  sms: _l,
  rewards: rl,
  covertDiscount: fr,
  covertCoins: Zi,
  faq: Dr,
  email: $r
}, he = Rn("component", () => {
  const e = J(!1), t = ["index"], n = J("fade"), s = J("index"), o = J({}), c = le(() => Pn[s.value]);
  function u(r, a = {}) {
    n.value = "fade", t.push(r), s.value = r, o.value = a;
  }
  function p(r = {}) {
    n.value = "back", t.pop(), s.value = t[t.length - 1] || "index", o.value = r;
  }
  function f() {
    e.value = !e.value, n.value = e.value ? "fade" : "back";
  }
  function l() {
    n.value = "fade", t.length = 0, t.push("index"), s.value = "index", o.value = {};
  }
  return { comp: s, setComp: u, currentComp: c, components: Pn, back: p, animateType: n, pageVisible: e, toggle: f, pageData: o, clearComp: l };
}), de = Rn("userinfo", () => {
  const e = J(null);
  async function t() {
    if (!Kt())
      return;
    const s = await ni();
    e.value = s;
  }
  function n() {
    e.value = null;
  }
  return Le(t), {
    userinfo: e,
    updateUserinfo: t,
    clearUserinfo: n
  };
}), bl = {
  id: "lute-redeem-app",
  class: "lute-redeem-app"
}, yl = {
  key: 0,
  class: "btn-label"
}, wl = {
  key: 1,
  class: "close-btn"
}, Cl = {
  __name: "App",
  setup(e) {
    const t = he(), n = Dt("buttonEl"), s = Dt("pageEl"), o = Io((g) => {
      localStorage.setItem("LUTE:REDEEM:BTN_TOP", g);
    }, 500), c = le(() => t.pageVisible), { y: u } = Ur(n, {
      safeArea: {
        top: 12,
        bottom: 12
      },
      disabled: c,
      initialValue: r,
      onEnd: (g) => {
        o(g.y);
      }
    }), p = Dt("btnRef"), f = J();
    function l() {
      f.value = p.value.children[0].offsetWidth;
    }
    async function r() {
      const g = localStorage.getItem("LUTE:REDEEM:BTN_TOP");
      if (!g || !Mo(Number(g))) {
        await vn();
        const S = n.value.getBoundingClientRect();
        return {
          x: 0,
          y: ((window.innerHeight || document.documentElement.clientHeight) - S.height) / 2
        };
      }
      return {
        x: 0,
        y: Number(g)
      };
    }
    Ee(() => c.value, (g) => {
      g ? document.documentElement.classList.add("is-scrollBlock") : document.documentElement.classList.remove("is-scrollBlock");
    });
    function a() {
      const g = new URLSearchParams(window.location.search);
      g.get("lt-redeem") && (g.delete("lt-redeem"), history.replaceState({}, "", `${window.location.pathname}${g.toString() ? `?${g.toString()}` : ""}`), w());
    }
    const v = J(null);
    async function m() {
      await vn();
      const g = n.value, S = s.value;
      if (!g || !S)
        return;
      const x = S.getBoundingClientRect(), R = g.getBoundingClientRect(), k = window.innerHeight || document.documentElement.clientHeight, C = window.innerWidth || document.documentElement.clientWidth;
      let I = R.top + (R.height - x.height) / 2;
      const E = 12, $ = 12, M = E, P = Math.max(M, k - x.height - $);
      I = Math.min(Math.max(I, M), P), v.value = {
        "--page-top": `${I}px`,
        "--page-right": `${C - R.left + 8}px`
      };
    }
    function w() {
      t.toggle(), t.pageVisible && m();
    }
    return Le(() => {
      a(), l();
    }), de(), Fr(), (g, S) => {
      const x = we("visible-track"), R = we("track");
      return h(), _("div", bl, [
        oe(Ht, { name: "page" }, {
          default: ve(() => [
            d(t).pageVisible ? G((h(), _("div", {
              key: 0,
              ref: "pageEl",
              class: "box-wrapper",
              role: "dialog",
              style: ze(v.value),
              onTouchmovePassive: S[0] || (S[0] = rt(() => {
              }, ["stop"]))
            }, [
              oe(Ht, {
                name: d(t).animateType
              }, {
                default: ve(() => [
                  (h(), me(yo, null, [
                    (h(), me(wo(d(t).currentComp), { class: "box" }))
                  ], 1024))
                ]),
                _: 1
              }, 8, ["name"])
            ], 36)), [
              [x, void 0, "visible:app"]
            ]) : Q("", !0)
          ]),
          _: 1
        }),
        i("div", {
          ref: "buttonEl",
          class: "btn-container",
          style: ze({ top: `${d(u)}px` })
        }, [
          G((h(), _("button", {
            ref_key: "btnRef",
            ref: p,
            class: ye(["btn", { opened: d(t).pageVisible }]),
            style: ze(`--btn-width: ${f.value}px`),
            onClick: w
          }, [
            d(t).pageVisible ? (h(), _("div", wl, [...S[2] || (S[2] = [
              i("i", { class: "lutefont icon-close" }, null, -1)
            ])])) : (h(), _("div", yl, [...S[1] || (S[1] = [
              i("i", { class: "lutefont icon-gift" }, null, -1),
              ee(" Rewards ", -1)
            ])]))
          ], 6)), [
            [R, { type: !d(t).pageVisible }, "click:redeem-btn"]
          ])
        ], 4)
      ]);
    };
  }
}, xl = /* @__PURE__ */ se(Cl, [["__scopeId", "data-v-e125f72c"]]), $l = {
  mounted(e, t) {
    if (!window.ltTrack)
      return;
    const n = t.arg || "track_event", s = t.value || {}, o = de(), { userinfo: c } = ne(o);
    e.__trackHandler__ = () => {
      var u, p;
      window.ltTrack(`redeem:${n}`, {
        ...s,
        userinfo: c.value ? {
          id: (u = c.value) == null ? void 0 : u.uid,
          email: (p = c.value) == null ? void 0 : p.email
        } : null
      });
    }, e.addEventListener("click", e.__trackHandler__);
  },
  unmounted(e) {
    window.ltTrack && (e.removeEventListener("click", e.__trackHandler__), delete e.__trackHandler__);
  }
}, El = {
  mounted(e, t) {
    if (!window.ltTrack)
      return;
    const n = t.arg || "visible_event", s = t.value || {}, o = de(), { userinfo: c } = ne(o), u = new IntersectionObserver((p) => {
      p.forEach((f) => {
        var l, r;
        f.isIntersecting && (window.ltTrack(`redeem:${n}`, {
          ...s,
          userinfo: c.value ? {
            id: (l = c.value) == null ? void 0 : l.uid,
            email: (r = c.value) == null ? void 0 : r.email
          } : null
        }), u.disconnect());
      });
    });
    u.observe(e), e.__vVisibleTrackObserver__ = u;
  },
  unmounted(e) {
    window.ltTrack && e.__vVisibleTrackObserver__ && (e.__vVisibleTrackObserver__.disconnect(), delete e.__vVisibleTrackObserver__);
  }
}, Sl = Co(xl, {
  configureApp(e) {
    e.use(uo()), e.directive("track", $l), e.directive("visible-track", El);
  },
  shadowRoot: !1
});
customElements.define("lute-redeem", Sl);
